import { ApiBase } from '@/service/api-base'
import { CancelToken } from 'axios'

export class AIListVo {
  /** ai视频类别 */
  aiType?: number

  /** ai视频类别转义 */
  aiTypeStr?: string

  /** id */
  id?: string

  /** 问题名称 */
  problemName?: string

  /** 问题状态 */
  problemStatus?: number

  /** 问题状态转义 */
  problemStatusStr?: string

  /** 时间 */
  reportTime?: string

  /** 河流 */
  river?: string
}

export class AISubscriptionPost {
  /** 订阅类型，不填默认订阅全部 */
  eventTypes?: string[]

  /** 回调地址 */
  url?: string
}

export class AssessmentRankingsDto {
  /** 单位名称 */
  companyName?: string

  /** 城镇排水污染监管 */
  czpswrjgScore?: string

  /** 化粪池清掏和河道清漂河岸垃圾污染监管 */
  hfchdqpljwrjgScore?: string

  /** 河长制工作落实 */
  hzzgzlsScore?: string

  /** id */
  id?: number

  /** 流域名称 */
  ly?: string

  /** 考核月份 */
  month?: string

  /** 农贸市场污染监管 */
  nmscwrjgScore?: string

  /** 区级河长 */
  qjhz?: string

  /** sort */
  sort?: number

  /** 水质考核排名 */
  szkhRanking?: string

  /** 水质考核得分 */
  szkhhjScore?: string

  /** 水质类别 */
  szlb?: string

  /** 养殖业污染监管 */
  yzywrjgScore?: string

  /** 镇街名次 */
  zjRanking?: string

  /** 镇街考核总分 */
  zjkhTotalScore?: string

  /** 专项整治及监管落实 */
  zxzzjjgls?: string
}

export class AutoSitePointByLyAndGkjbQuery {
  /** 流域名称 */
  ly?: string

  /** month 格式 yyyy-MM */
  month?: string

  /** 查询类型 */
  type?: string
}

export class AutoSiteSzskQuery {
  /** 时间格式（yyyy-MM-dd HH） */
  date?: string

  /** 流域名称 */
  ly?: string

  /** 站点类型 */
  type?: string
}

export class BasicClickPointListQuery {
  /** 流域名称 */
  ly?: string

  /** 获取数据类型编号 */
  no?: number

  /** 河流 */
  river?: string
}

export class BasicDataListStatisticsVo {
  hz?: BasicDataStatisticsVo
  sgdm?: BasicDataStatisticsVo
  sk?: BasicDataStatisticsVo
  spjk?: BasicDataStatisticsVo
  swsl?: BasicDataStatisticsVo
  wgy?: BasicDataStatisticsVo
  wry?: BasicDataStatisticsVo
  yjpk?: BasicDataStatisticsVo
  yys?: BasicDataStatisticsVo
  zdz?: BasicDataStatisticsVo
}

export class BasicDataStatisticsVo {
  children?: StatisticsCountDto[]
  count?: number
  name?: string
  no?: number
}

export class BasicStatisticsQuery {
  /** 流域名称 */
  ly?: string

  /** 河流 */
  river?: string
}

export class CallInfoDto {
  /** 房间号 */
  channelNo?: string

  /** 状态 1表示请求通话   2表示通话中  3表示挂断 */
  status?: number

  /** 用户id */
  userId?: number
}

export class CameraControllingQuery {
  /** 0 停止 1开始 */
  action?: number

  /** 摄像头设备id */
  cameraIndexCode?: string

  /** LEFT 左转 RIGHT 右转 UP 上转 DOWN 下转 ZOOM_IN 焦距变大 ZOOM_OUT 焦距变小 LEFT_UP 左上 LEFT_DOWN 左下 RIGHT_UP 右上 RIGHT_DOWN 右下 FOCUS_NEAR 焦点前移 FOCUS_FAR 焦点后移 IRIS_ENLARGE 光圈扩大 IRIS_REDUCE 光圈缩小  */
  command?: string
}

export class CameraStreamDto {
  /** 接入方式 */
  accessMode?: number

  /** 摄像头监测设备id */
  deviceId?: string

  /** 设备名称 */
  deviceName?: string

  /** 是否是海康威视视频 true 是  false 否 */
  hkVideo?: boolean
  id?: string

  /** 视频流 */
  videoStream?: string
}

export class CommonPointVo {
  /** 类别用于区分类型 gk,sk,qk,一体化yth,物联站wlz,水库sk 等 */
  category?: string

  /** id */
  id?: string

  /** 经度 */
  jd?: string

  /** 名称 */
  name?: string

  /** 是否在线，在线true , 不在线false */
  online?: boolean

  /** 是否超标   达标db , 超标cb, 无数据wsj */
  standard?: string

  /** 视频流地址 */
  videoStream?: string

  /** 水质等级评价 */
  waterLevel?: number

  /** 纬度 */
  wd?: string
}

export class CommonStatisticsDto {
  /** 名称 */
  name?: string

  /** 数量 */
  value?: number
}

export class CyqyEntity {
  /** 登记机构 */
  djjg?: string

  /** 法定代表人 */
  fddbr?: string

  /** 负责人 */
  fzr?: string

  /** 负责人_联系电话 */
  fzrLxfs?: string

  /** 管理人 */
  glr?: string

  /** 管理人_联系方式 */
  glrLxfs?: string

  /** 行业类别 */
  hylb?: string

  /** id */
  id?: string

  /** 经度 */
  jd?: string

  /** 经营范围 */
  jyfw?: string

  /** 经营类别 */
  jylb?: string

  /** 企业类型 */
  qylx?: string

  /** 企业名称 */
  qymc?: string

  /** 所在地址 */
  szdz?: string

  /** 纬度 */
  wd?: string

  /** 行政区划代码 */
  xzqhdm?: string

  /** 行政区划名称 */
  xzqhmc?: string

  /** 状态 */
  zt?: string
}

export class DfBasicDTO {
  /** 保护范围划界 */
  bhfwhj?: string

  /** 达标长度(m) */
  dbcd?: string

  /** 堤防编码 */
  dfbm?: string

  /** 堤防长度 */
  dfcd?: string

  /** 堤防级别 */
  dfjb?: string

  /** 堤防跨界情况 */
  dfkjqk?: string

  /** 堤防类型 */
  dflx?: string

  /** 堤防名称 */
  dfmc?: string

  /** 堤防型式 */
  dfxs?: string

  /** 工程归口管理部门 */
  gcgkglbm?: string

  /** 工程任务 */
  gcrw?: string

  /** geometry */
  geometry?: string

  /** 管理单位 */
  gldw?: string

  /** 管理单位权属 */
  gldwqs?: string

  /** 管理单位性质 */
  gldwxz?: string

  /** 管理单位责任人 */
  gldwzrr?: string

  /** 管理单位责任人电话 */
  gldwzrrdh?: string

  /** 管理单位责任人职务 */
  gldwzrrzw?: string

  /** 管理范围划界 */
  glfwhj?: string

  /** 管理范围确权 */
  glfwqq?: string

  /** 河流岸别 */
  hlab?: string

  /** 河流名称 */
  hlmc?: string

  /** 湖泊名称 */
  hpmc?: string

  /** 海洋名称 */
  hymc?: string

  /** id */
  id?: string

  /** 监控类型 */
  jklx?: string

  /** 纬度 */
  lat?: string

  /** 经度 */
  lon?: string

  /** 起点所在村 */
  qdszCun?: string

  /** 起点所在省 */
  qdszSheng?: string

  /** 起点所在市 */
  qdszShi?: string

  /** 起点所在县 */
  qdszXian?: string

  /** 起点所在乡(镇) */
  qdszZhen?: string

  /** 起点所在地 */
  qdszd?: string

  /** 起点桩号 */
  qdzh?: string

  /** 省级单位 */
  sjdw?: string

  /** 上级主管单位 */
  sjzgdw?: string

  /** 所属水系 */
  sxmc?: string

  /** 终点所在省 */
  zdszSheng?: string

  /** 终点所在市 */
  zdszShi?: string

  /** 终点所在村 */
  zdszUn?: string

  /** 终点所在县(区) */
  zdszXian?: string

  /** 终点所在乡(镇) */
  zdszZhen?: string

  /** 终点所在地 */
  zdszd?: string

  /** 终点桩号 */
  zdzh?: string

  /** 政府防汛责任人 */
  zffxzrr?: string

  /** 政府防汛责任人电话 */
  zffxzrrdh?: string

  /** 政府防汛责任人职务 */
  zffxzrrzw?: string

  /** 主管单位性质 */
  zgdwxz?: string

  /** 主管单位责任人 */
  zgdwzrr?: string

  /** 主管单位责任人电话 */
  zgdwzrrdh?: string

  /** 主管单位责任人职务 */
  zgdwzrrzw?: string

  /** 最近达标加固完成时间 */
  zjdbjgwcsj?: string

  /** 最近加固达标完工状态 */
  zjjgdbwgzt?: string
}

export class DfInfoDto {
  /** 起点所在地 */
  beginAddress?: string

  /** 起点桩号 */
  beginCode?: string

  /** 堤防长度 */
  dfcd?: string

  /** 堤防跨界情况 */
  dfkjqk?: string

  /** 终点点所在地 */
  endAddress?: string

  /** 终点桩号 */
  endCode?: string

  /** 管理单位 */
  gldw?: string

  /** 管理单位权属 */
  gldwqs?: string

  /** 管理单位性质 */
  gldwxz?: string

  /** 河流岸别 */
  hlab?: string

  /** 河流名称 */
  hlmc?: string

  /** 纬度 */
  lat?: string

  /** 经度 */
  lon?: string

  /** 联系电话 */
  lxfs?: string

  /** 数据类型 1：拦河坝 2：'水闸 */
  name?: string

  /** 省级单位 */
  sjdw?: string

  /** 上级主管单位 */
  sjzgdw?: string

  /** 堤防类型 */
  subtype?: string

  /** 管理单位责任人 */
  zrr?: string

  /** 责任人职务 */
  zrrzw?: string
}

export class DfInfoOverviewResDto {
  /** 左岸数量 */
  leftTotal?: number

  /** 右岸数量 */
  rightTotal?: number

  /** 总数量 */
  total?: number
}

export class DmYzDatumLine {
  /** 基准线 */
  datumLine?: number

  /** 单位 */
  unit?: string
}

export class DmYzDatumLineQuery {
  /** 标准水质类别 */
  bzszlb?: number

  /** 因子 */
  code?: string

  /** 水体类型 */
  stlx?: string
}

export class DotMapDto {
  /** 类别 */
  category?: string

  /** 分类名称 */
  categoryStr?: string

  /** 管控级别 */
  gkjb?: string

  /** id */
  id?: string

  /** 经度 */
  jd?: string

  /** 名称 */
  name?: string

  /** 是否在线，在线true , 不在线false */
  online?: boolean

  /** 排口列表 */
  outPuts?: WsclcInfoItemsDto[]

  /** 水质等级 */
  pollutionLevel?: string

  /** 是否超标   达标db , 超标cb, 无数据wsj */
  standard?: string

  /** 纬度 */
  wd?: string
}

export class DropBoxDto {
  /** 名称 */
  name?: string

  /** 值 */
  value?: string
}

export class DropBoxIntegerDto {
  /** 名称 */
  name?: string

  /** 值 */
  value?: number
}

export class DropDownDto {
  /** 名称 */
  name?: string

  /** 内容 */
  value?: string
}

export class DutyDepTargetTaskVo {
  /** 责任部门 */
  dutyDepartment?: string

  /** id */
  id?: number

  /** 现状（2020年）指标值 */
  indicatorValueOne?: string

  /** 预期（2025年）指标值 */
  indicatorValueThree?: string

  /** 预期（2023年）指标值 */
  indicatorValueTwo?: string

  /** 主要指标 */
  primaryIndicator?: string

  /** 备注 */
  remake?: string

  /** 具体任务 */
  specificTask?: string

  /** 任务级别 */
  taskLevel?: string

  /** 指标单位 */
  unit?: string
}

export class EventDetailDto {
  /** 问题所在地址 */
  address?: string

  /** 上报人 */
  createUser?: string

  /** 问题描述 */
  description?: string

  /** 紧急程度 */
  emergencyDegreeStr?: string

  /** 附件列表 */
  fileList?: ZkProblemFileDto[]

  /** id列表 */
  idList?: string[]

  /** 问题所在纬度 */
  latitude?: number

  /** 问题所在经度 */
  longitude?: number

  /** 合并id */
  mergeId?: string

  /** 监测数据 */
  monitorDataDto?: MonitorDataSubjectDto

  /** 当前登录人可以进行的操作列表：['zj:转交','bl:办理','bj:办结','th:退回'] */
  operations?: string[]

  /** 当前任务id */
  problemId?: string

  /** 任务名称 */
  problemName?: string

  /** 问题来源 1:告警推送  2:问题上报  3:任务发布 */
  problemSource?: number

  /** 问题来源 */
  problemSourceStr?: string

  /** 问题状态 */
  problemStatus?: number

  /** 问题状态 */
  problemStatusStr?: string

  /** 问题二级分类 */
  problemSubtype?: number

  /** 问题二级分类转义文字 */
  problemSubtypeStr?: string

  /** 问题类型 */
  problemTypeStr?: string

  /** 上报时间 */
  reportTime?: string

  /** 上报时间Str */
  reportTimeStr?: string

  /** 问题所在流域河段 */
  river?: string

  /** 处理流程 */
  workflowRecordTree?: WorkflowRecordTreeDto[]
}

export class FactorSubjectDto {
  /** 因子编码 */
  factorCode?: string

  /** 因子名称 */
  factorName?: string

  /** 展示排序 */
  sort?: number

  /** 标准值 */
  standValues?: number[]

  /** 单位 */
  unit?: string
}

export class GkSkWaterDto {
  /** 数据日期 */
  jcsj?: string

  /** 水质类别罗马 */
  pjjb?: string

  /** 水质类别数字 */
  pjjbn?: string
}

export class GkSkWaterResDto {
  /** 上年年度水质集合 */
  lastData?: GkSkWaterDto[]

  /** 年度水质集合 */
  nowData?: GkSkWaterDto[]
  zywrw?: any[]
}

export class GnfqQuery {
  /** 功能分区级别 1:一级 2:二级 */
  level?: number

  /** 流域名称 */
  ly?: string
}

export class GridWgyRecordQuery {
  /** 开始时间 */
  beginTime?: string

  /** 结束时间 */
  endTime?: string

  /** 用户id */
  userId?: number
}

export class GridXcRecordBaseInfoDto {
  /** 所在河流 */
  hl?: string

  /** 巡查记录id */
  id?: number

  /** 重点监管点 */
  prints?: string

  /** 起点名称 */
  qdmc?: string

  /** 所在镇街名称 */
  szzjmc?: string

  /** 网格员id */
  userId?: number

  /** 终点名称 */
  zdmc?: string

  /** 网格员名称 */
  zrrUserName?: string

  /** 联系电话 */
  zrrUserTel?: string
}

export class GridXcRecordDto {
  /** 巡查记录 */
  records?: GridXcRecordReportDto[]

  /** 实巡数 */
  sxs?: number

  /** 应巡数 */
  yxs?: number
}

export class GridXcRecordReportDto {
  /** 开始时间 */
  beginTime?: string

  /** 日期 */
  date?: string

  /** 打卡次数 */
  dkCount?: number

  /** 结束时间 */
  endTime?: string

  /** id */
  id?: number

  /** 上报问题数 */
  reportProblemCount?: number

  /** 巡河里程 */
  xhlc?: number

  /** 总时长（h） */
  zsc?: number
}

export class GscInfoDto {
  /** 详细地址 */
  addres?: string

  /** 日均供水能力 */
  dailyOutput?: string

  /** 供水范围 */
  gsfw?: string

  /** 供水规模 */
  gsgm?: string

  /** 供水人口 */
  gsrk?: string

  /** 供水水厂个数 */
  gsscgs?: string

  /** 供水水厂组成 */
  gssczc?: string

  /** 纬度 */
  lat?: string

  /** 经度 */
  lon?: string

  /** 管理范围面积 */
  manageArea?: string

  /** 日均最大供水能力 */
  maxDailyOutput?: string

  /** 名称 */
  name?: string

  /** 工程状态 */
  projectStatus?: string

  /** 保护范围面积 */
  protectArea?: string

  /** 所在河流 */
  szhl?: string

  /** 类型 */
  type?: string

  /** 取水水源 */
  waterSource?: string

  /** 所在镇街 */
  zj?: string
}

export class GscInfoOverviewResDto {
  /** 饼状图 */
  pieChart?: Record<string, any>[]

  /** 总数量 */
  total?: number

  /** 已建数量 */
  yjTotal?: number

  /** 在建数量 */
  zjTotal?: number
}

export class GyqyInfoPopDto {
  /** 行业名称 */
  hymc?: string

  /** ID */
  id?: string

  /** 经度 */
  jd?: number

  /** 联系人电话 */
  lxrdh?: string

  /** 联系人姓名 */
  lxrxm?: string

  /** 排污许可证代码 */
  pwxkzdm?: string

  /** 企业规模 */
  qygm?: string

  /** 受纳水体 */
  snst?: string

  /** 统一社会信用代码 */
  tyshxydm?: string

  /** 纬度 */
  wd?: number

  /** 污染源名称 */
  wrymc?: string

  /** 详细地址 */
  xxd?: string

  /** 组织机构代码 */
  zzkgdm?: string
}

export class GyyqEntity {
  cym?: string

  /** 地址 村 */
  dzCun?: string

  /** 地址 省 */
  dzSheng?: string

  /** 地址 市 */
  dzShi?: string

  /** 地址 县 */
  dzXian?: string

  /** 地址 乡 */
  dzXiang?: string

  /** 负责人 */
  fzr?: string

  /** 负责人电话 */
  fzrdh?: string

  /** 规划环评批准号 */
  ghhpbzh?: string

  /** 管理单位 */
  gldw?: string

  /** 管理级别 */
  gljb?: string
  gndw?: string
  id?: string

  /** 基本介绍 */
  jbjs?: string

  /** 经度 */
  jd?: string

  /** 建设状态 */
  jszt?: string

  /** 集中式污水处理设施数 */
  jzwsclsss?: number

  /** 联系人 */
  lxr?: string

  /** 联系人电话 */
  lxrdh?: string

  /** 排污口情况 距三江距离 */
  pwkqkJsjjl?: string

  /** 排污口数量 */
  pwkqkSl?: string

  /** 排污去向 */
  pwqx?: string

  /** 入园企业数量 */
  ryqyjs?: number

  /** 是否开展规划环评 */
  sfKzghhp?: string

  /** 是否商用工业园区 */
  sfSygyyq?: string
  sfsc?: string
  sjlx?: string

  /** 受纳水体 */
  snst?: string
  snstfhl?: string
  snstid?: string
  sssx?: string
  sssxid?: string

  /** 所在地址 */
  szdz?: string

  /** 纬度 */
  wd?: string
  xzqhdm?: string
  xzqhmc?: string
  yqdm?: string

  /** 园区级别 */
  yqjb?: string
  yqmc?: string

  /** 园区面积 */
  yqmj?: string

  /** 园区实际处理 */
  yqsjcll?: number

  /** 园区设计处理能力 */
  yqsjclnl?: number

  /** 已完成在线监控装置安装并联网数 */
  ywczxjkzzazblws?: string

  /** 运行状态 */
  yxzt?: string

  /** 主导行业 */
  zdhy?: string

  /** 组团名称 */
  ztmc?: string

  /** 在线监测的主要因子 */
  zxjczyyz?: string

  /** 执行排放标准 */
  zxpfbz?: string
}

export class GyyqInfoCountStatisticsVo {
  /** 集中污水处理设施数量 */
  jzwsclssCount?: number

  /** 入园企业数量 */
  ryqyCount?: number

  /** 园区及组团数 */
  totalCount?: number
}

export class GyyqInventoryVo {
  /** 所属区域 */
  ssqy?: string

  /** 园区名称 */
  yqmc?: string

  /** 组团名称 */
  ztmc?: string
}

export class HandleProblemListDTO {
  id?: string
  jd?: number

  /** 问题名称 */
  problemName?: string

  /** 问题状态 */
  problemStatus?: number

  /** 问题状态转义 */
  problemStatusStr?: string

  /** 问题类别 */
  problemSubtypeStr?: string

  /** 上报时间 */
  reportTime?: string

  /** 单位 */
  unit?: string

  /** 上报人 */
  username?: string
  wd?: number
}

export class HdhjEntity {
  /** 岸线资源面积 */
  axzymj?: number

  /** id */
  id?: number

  /** 界桩数量 */
  jzsl?: number

  /** 流域 */
  ly?: string

  /** 划界名称 */
  name?: string

  /** 起点名称 */
  qdmc?: string

  /** 重点名称 */
  zdmc?: string
}

export class HkaxStatisticsVo {
  /** 河道总数 */
  hdzs?: number

  /** 河流总数 */
  hlzs?: number

  /** 界桩总数 */
  jzzs?: number
}

export class HomeDropSelect {
  children?: HomeDropSelect[]
  name?: string
  value?: string
}

export class HzCountStatisticsVo {
  /** 部门河长数量 */
  bmhzsl?: number

  /** 村级河长数量 */
  cjhzsl?: number

  /** 河长总数 */
  hzzs?: number

  /** 流域区责任人数量 */
  lyzrrsl?: number

  /** 区常务副总河长 */
  qcwfzhzsl?: number

  /** 区副总河长 */
  qfzhzsl?: number

  /** 区级河长数量 */
  qjhzsl?: number

  /** 区总和长 */
  qzhzsl?: number

  /** 镇街河长数量 */
  zjhzsl?: number
}

export class HzPopInfoQuery {
  /** 查询条件，河长级别 */
  level?: string
  ly?: string

  /** 镇街 */
  zj?: string
}

export class HzXhRecordQuery {
  /** 任务开始时间（yyyy-MM） */
  beginTime?: string

  /** 任务结束时间（yyyy-MM） */
  endTime?: string

  /** 流域 */
  ly?: string
}

export class HzXhStatisticsQuery {
  /** 行政级别 1:部门 2:区级 3:镇街 4:村居 */
  level?: string

  /** 流域 */
  ly?: string

  /** 周期(季度或月份):第一季度 或 2022-01 */
  period?: string
}

export class HzbProblemStatisticsDTO {
  /** 处理中问题数 */
  doingProblemCount?: number

  /** 处置问题数(已处理) */
  handleProblemCount?: number

  /** 处置率 */
  handleRate?: string
}

export class HzddProblemListDto {
  /** 分类 */
  category?: string

  /** 自动告警编码 */
  deviceMn?: string

  /** 污染因子 */
  factorCode?: string

  /** id */
  id?: string

  /** 纬度 */
  latitude?: string

  /** 经度 */
  longitude?: string

  /** 问题名称 */
  problemName?: string

  /** 处理状态 */
  problemStatus?: number

  /** 处理状态注释 */
  problemStatusStr?: string

  /** 问题类别二级分类 */
  problemSubtype?: number

  /** 问题类别二级分类名称 */
  problemSubtypeStr?: string

  /** 问题类别 */
  problemType?: number

  /** 问题类别名称 */
  problemTypeStr?: string

  /** 上报时间 */
  reportTime?: string
}

export class HzlInfoDto {
  /** 文件地址 */
  fileUrl?: string

  /** id */
  id?: number

  /** 序号 */
  orderName?: string

  /** 发布时间 */
  publishTime?: string

  /** 标题 */
  title?: string

  /** 河长令类型 */
  type?: string
}

export class HzlInfoQeqDto {
  /** 河长令类型 */
  type?: string
}

export class HzxhCountStatisticsQuery {
  /** 流域名称 */
  ly?: string

  /** 频次, d, w, m, y */
  period?: string

  /** 是否完成巡河 全部，未完成，已完成 */
  xhwczt?: string
}

export class HzxhCountStatisticsVo {
  /** 正在巡河人数 */
  doingXhCount?: number

  /** 完成率 */
  finishRate?: number

  /** 实巡数量 */
  sxCount?: number

  /** 总里程数 */
  totalDistance?: number

  /** 总时长 */
  totalTime?: number

  /** 应巡数量 */
  yxCount?: number
}

export class HzxhProblemListQuery {
  /** 重要程度 */
  emergencyDegree?: string

  /** 流域 */
  ly?: string

  /** 频次, d, w, m */
  period?: string

  /** 问题类型二级分类下拉 */
  problemSubtype?: string

  /** 问题类型 */
  problemType?: string
}

export class IdDto {
  /** 序号id */
  id?: number
}

export class IdIntegerQuery {
  id?: number
}

export class IdStringQuery {
  /** id */
  id?: string
}

export class JgyStatisticsVO {
  /** 监管员数量 */
  jgyCount?: number

  /** 处理中问题数 */
  problemDoingCount?: number

  /** 已处理问题数 */
  problemOverCount?: number

  /** 发现问题总数 */
  problemTotalCount?: number
}

export class JsonResult {
  code?: number
  data?: any
  msg?: string
}

export class JsonTypeDto {
  /** 类型  image:图片 */
  type?: string

  /** 地址url */
  url?: string
}

export class KeyTaskResolveEntity {
  /** 配合单位名称 */
  cooperateDepartmentName?: string
  createTime?: string

  /** 责任单位 */
  dutyDepartmentName?: string

  /** 是否完成 */
  finish?: string
  id?: number
  ly?: string

  /** 主要问题 */
  mainProblem?: string

  /** 完成时限 */
  overTime?: string

  /** 任务级别 */
  problemLevel?: number

  /** 问题分类 */
  problemType?: string

  /** 推进情况 */
  promoteSituation?: string

  /** 措施内容 */
  protectiveMeasure?: string

  /** 任务级别 */
  rwjb?: string

  /** 所在位置 */
  szwz?: string

  /** 任务年份 */
  taskTime?: number
}

export class LastDateTimeDTO {
  /** 自动站最新监测时间 */
  autoSiteLastDateTime?: string

  /** 手工断面最新监测时间 */
  sgDmLastDateTime?: string
}

export class LyAndMonthQuery {
  /** 流域名称 */
  ly?: string

  /** 月份,格式：yyyy-MM */
  month?: string
}

export class LyAndPkLxQuery {
  /** 流域名称 */
  ly?: string
  pklx?: string
}

export class LyAndYearQuery {
  ly?: string
  year?: number
}

export class LyAndZjQuery {
  ly?: string

  /** 镇街 */
  zj?: string
}

export class LyQuery {
  /** 流域名称 */
  ly?: string
}

export class LygkCountStatisticsVo {
  /** 河流长度 */
  hlcd?: number

  /** 河流总数 */
  hlzs?: number

  /** 落差 */
  lc?: number

  /** 流域总面积KM^2 */
  lyzmj?: number

  /** 区级河流数量 */
  qjhlsl?: number

  /** 支流数量 */
  zlsl?: number
}

export class MonitorDataGroupDto {
  /** 各个设备的监测数据 */
  datas?: Record<string, any>[]

  /** 综合表头 */
  titles?: TitleModel[]
}

export class MonitorDataListDto {
  /** 监测时间 */
  dataTime?: string

  /** 因子 */
  factor?: string

  /** 监测值 */
  value?: number
}

export class MonitorDataSubjectDto {
  /** 监测数据列表 */
  dataList?: MonitorDataListDto[]

  /** 设备mn */
  deviceMn?: string

  /** 因子编码 */
  factorCode?: string

  /** 因子名称 */
  factorName?: string

  /** 标准值 */
  standValues?: number[]

  /** 因子单位 */
  unit?: string
}

export class MonitorSubjectDto {
  /** 超标标识（Y/N） */
  ex?: string

  /** 因子编码 */
  factorCode?: string

  /** 因子名称 */
  factorName?: string

  /** 监测值 */
  monitorValue?: number

  /** 展示排序 */
  sort?: number
}

export class MonitorVideoDto {
  /** 展开对象 */
  childs?: MonitorVideoDto[]

  /** 标题名称 */
  title?: string

  /** 监控视频列表 */
  videos?: MonitorVideoInfoDto[]
}

export class MonitorVideoInfoDto {
  /** 接入方式 */
  accessMode?: number

  /** 设备id,用于枪球一体去重 */
  deviceCode?: string

  /** 设备id */
  deviceId?: string

  /** 设备名 */
  deviceName?: string

  /** 是否是海康威视视频 true 是  false 否 */
  hkVideo?: boolean

  /** id */
  id?: string

  /** 纬度 */
  latitude?: string

  /** 经度 */
  longitude?: string

  /** 是否在线 1-是 2-否 */
  onlined?: number

  /** 排序用 */
  sort?: number

  /** 站点名称 */
  stationName?: string

  /** 视频流地址 */
  videoStream?: string

  /** 视频类型 */
  videoType?: number
}

export class NmscEntity {
  /** 备注 */
  bz?: string

  /** 地址 */
  dz?: string

  /** 负责人 */
  fzr?: string

  /** 负责人电话 */
  fzrdh?: string

  /** id */
  id?: string

  /** 经度 */
  jd?: string

  /** 类别 */
  lb?: string

  /** 名称 */
  mc?: string

  /** 市场面积 */
  scmj?: string

  /** 是否临河 */
  sflh?: string

  /** 数据量 */
  sjl?: string

  /** 所属社区 */
  sssq?: string

  /** 水体名称 */
  stmc?: string

  /** 纬度 */
  wd?: string

  /** 行政区划代码 */
  xzqhdm?: number

  /** 行政区划名称 */
  xzqhmc?: string
}

export class OnlineWgyItemInfoDto {
  /** 巡河记录id */
  id?: number

  /** 分项id */
  itemId?: number

  /** 经度 */
  jd?: string

  /** 重点监管点 */
  prints?: WgyItemPrintDto[]

  /** 起点经度 */
  qdjd?: string

  /** 起点名称 */
  qdmc?: string

  /** 起点纬度 */
  qdwd?: string

  /** 巡河人id */
  userId?: number

  /** 巡河人名称 */
  userName?: string

  /** 纬度 */
  wd?: string

  /** 巡河轨迹 */
  zb?: any[][]

  /** 终点经度 */
  zdjd?: string

  /** 终点名称 */
  zdmc?: string

  /** 终点纬度 */
  zdwd?: string
}

export class ParseMessageColumnDto {
  /** 表头英文key */
  key?: string

  /** 表头中文解释 */
  title?: string
}

export class PkDetailDto {
  /** 所在河流 */
  hl?: string
  id?: string

  /** 排口名称 */
  jcdmc?: string

  /** 类别 */
  lb?: string

  /** 所在流域 */
  ly?: string

  /** 所在镇街 */
  szzj?: string
}

export class PkListVo {
  /** id */
  id?: string

  /** 经度 */
  jd?: string

  /** 排口名称 */
  pkmc?: string

  /** 排污口类型 */
  pwkbm?: string

  /** 纬度 */
  wd?: string
}

export class ProblemCountClassifiedStatisticsDTO {
  /** 对应类型的已处理数量 */
  doingList?: number[]

  /** 类型名称 */
  nameList?: string[]

  /** 对应类型名称的总数 */
  totalList?: number[]
}

export class ProblemCountStatisticsDTO {
  /** 处理中数量 */
  doingCount?: number

  /** 完结数量 */
  overCount?: number

  /** 问题总数 */
  totalCount?: number
}

export class ProblemFileDto {
  /** 文件路径 */
  filePath?: string

  /** 文件类型 */
  fileType?: string

  /** 模块id（问题id/流程id） */
  modelId?: string

  /** 所属模块（1.问题附件，2流程附件） */
  modelType?: number

  /** 文件请求地址 */
  url?: string
}

export class ProblemMeasuresDto {
  /** 责任单位 */
  dutyDepartmentName?: string

  /** 完成情况 */
  finish?: string

  /** 流域 */
  ly?: string

  /** 主要问题 */
  mainProblem?: string

  /** 问题类别 */
  problemType?: string

  /** 措施内容 */
  protectiveMeasure?: string
}

export class ProblemMeasuresRateStatisticsDto {
  /** 问题数量 */
  count?: string

  /** 问题所占比列 */
  percentage?: string

  /** 问题措施类别 */
  problemType?: string
}

export class ProblemRecordDto {
  /** 问题所在地址 */
  address?: string

  /** 上报人（id） */
  createUserId?: number

  /** 上报人 */
  createUserName?: string

  /** 处理期限 */
  deadline?: number

  /** 问题描述 */
  description?: string

  /** 设备mn */
  deviceMn?: string

  /** 紧急程度  1:一般  2:重要  3:紧急 */
  emergencyDegree?: number

  /** 紧急程度 */
  emergencyDegreeStr?: string

  /** 告警因子编码 */
  factorCode?: string

  /** 告警因子名称 */
  factorName?: string

  /** 附件 */
  files?: ProblemFileDto[]

  /** id */
  id?: string

  /** 问题所在纬度 */
  latitude?: number

  /** 问题所在经度 */
  longitude?: number

  /** 合并id */
  mergeId?: string

  /** 合并人id */
  mergeUserId?: string

  /** 合并人 */
  mergeUserName?: string

  /** 问题名称 */
  problemName?: string

  /** 问题来源 1:告警推送  2:问题上报  3:任务发布 */
  problemSource?: number

  /** 问题来源Str */
  problemSourceStr?: string

  /** 问题状态 1:待处理 2:处理中 3:已办结 */
  problemStatus?: number

  /** 问题状态Str */
  problemStatusStr?: string

  /** 问题子分类 */
  problemSubtype?: number

  /** 问题类型 */
  problemType?: number

  /** 问题类型Str */
  problemTypeStr?: string

  /** 上报时间 */
  reportTime?: string

  /** 问题所在流域河段 */
  river?: string

  /** 发送短信通知：1是，0否 */
  sendSms?: number

  /** 巡查范围：1城区内，2城区外（包含一周一次/一天一次），3其它 */
  xcfw?: number

  /** 巡查范围Str */
  xcfwStr?: string
}

export class QskInfoDto {
  /** 内容 */
  content?: string

  /** 所处生态敏感区 */
  ecologyArea?: string

  /** 纬度 */
  lat?: string

  /** 经度 */
  lon?: string

  /** 名称 */
  name?: string

  /** 保护范围 */
  protectArea?: string

  /** 用途 */
  purpose?: string

  /** 规模 */
  scale?: string

  /** 水资源类型 */
  type?: string

  /** 年取水量 */
  yearQsl?: string

  /** 占用岸线长度 */
  zyaxcd?: string
}

export class QskInfoOverviewResDto {
  /** 饼状图 */
  pieChart?: Record<string, any>[]

  /** 总数量 */
  total?: number
}

export class RankingTimesDto {
  /** 年月 */
  month?: string

  /** 时间 年月日 */
  time?: string

  /** 年份 */
  year?: string
}

export class RankingsListDtos {
  /** 单位名称/镇街名称 */
  companyName?: string

  /** 流域 */
  ly?: string

  /** 考核月份 */
  month?: string

  /** 区级河段长 */
  qjhdz?: string

  /** 镇街名次 */
  zjRanking?: string

  /** 镇街考核总分 */
  zjkhTotalScore?: string
}

export class RiverCruiseBaseStatisticsDto {
  /** 巡查完成百分比 */
  cruiseFinishPercentage?: string

  /** 总巡河时长 */
  cruiseTimeLength?: string

  /** 主键id */
  id?: number

  /** 行政级别 1:部门 2:区级 3:镇街 4:村居 */
  level?: string

  /**  河流流域 */
  ly?: string

  /** 周期(季度或月份) */
  period?: string

  /** 实巡次数 */
  realCruiseNum?: number

  /** 应巡次数 */
  shouldCruiseNum?: number

  /** 总巡河里程 */
  tourRiverMiles?: string
}

export class RiverCruiseDistrictRecordDto {
  /** 行政区域 */
  administrativeAre?: string

  /** 创建时间 */
  createTime?: string

  /** 巡查完成百分比 */
  cruiseFinishPercentage?: string

  /** 主键id */
  id?: number

  /**  行政级别 1:部门 2:区级 3:镇街 4:村居 */
  level?: string

  /**  河流流域 */
  ly?: string

  /** 周期(季度或月份) */
  period?: string

  /** 实巡次数 */
  realCruiseNum?: number

  /** 应巡次数 */
  shouldCruiseNum?: number

  /** 修改时间 */
  updateTime?: string
}

export class RiverCruiseRecordDto {
  /** 起点 */
  beginPrint?: string

  /** 巡河人 */
  cruisePeople?: string

  /** 巡河时长 */
  cruiseTimeLength?: string

  /** 巡河有效性 */
  effectiveness?: string

  /** 重点监管点 */
  empPrint?: string

  /** 终点 */
  endPrint?: string

  /** 终点坐标 */
  endPrintIndex?: string

  /** 结束时间 */
  endTime?: string

  /** 附件信息 */
  files?: string

  /** 河段名称 */
  hdName?: string

  /** 巡河id */
  id?: number

  /** 附件信息 */
  jsonTypeDtoList?: JsonTypeDto[]

  /** 流域 */
  ly?: string

  /** 联系电话 */
  phonenumber?: string

  /** 职务 */
  position?: string

  /** 上报问题数 */
  questionNumber?: number

  /** 记录事项 */
  recordMatters?: string

  /** 河流 */
  river?: string

  /** 起点坐标 */
  startPrintIndex?: string

  /** 开始 */
  startTime?: string

  /** 巡河公里数 */
  tourRiverMiles?: number

  /** 镇街 */
  zj?: string
}

export class RiverInfoDto {
  /** 河流长度 */
  hlcd?: string

  /** 河流名称 */
  hlmc?: string

  /** 流域面积 */
  lymj?: number

  /** 支流数量 */
  zlsl?: string
}

export class RiverLeaderStatisticsVo {
  /** 部门河长数量 */
  bmhzsl?: number

  /** 村级河长数量 */
  cjhzsl?: number

  /** 河长总数 */
  hzzs?: number

  /** 流域区河长数量 */
  lyzrrsl?: number

  /** 区常务副总河长 */
  qcwfzhzsl?: number

  /** 区副总河长 */
  qfzhzsl?: number

  /** 区级河长数量 */
  qjhzsl?: number

  /** 区总和长 */
  qzhzsl?: number

  /** 河长人员数据 */
  riverLeaders?: RiverLeaderTreeDto[]

  /** 镇街河长数量 */
  zjhzsl?: number
}

export class RiverLeaderTreeDto {
  /** 子级 */
  child?: RiverLeaderTreeDto[]

  /** 名称 */
  name?: string

  /** 联系河段 */
  river?: string

  /** 排序 */
  sort?: number

  /** 所在镇街 */
  szzj?: string

  /** 河长级别 */
  type?: string

  /** 温馨提示 */
  warmPrompt?: string

  /** 职务 */
  zw?: string
}

export class SKBasicInfoReqDto {
  /** 水库，水闸，堤防名称 */
  hkmc?: string

  /** 湖库id */
  id?: string

  /** 流域 */
  ly?: string

  /** 当前页码 列表必传 */
  pageNow?: number

  /** 数量 列表必传 */
  pageSize?: number

  /** 水库，水闸，堤防类型：左岸 右岸 */
  type?: string
}

export class ScyzDetailDto {
  /** 详细地址 */
  dz?: string

  /** 负责人 */
  fzr?: string

  /** ID */
  id?: string

  /** 经度 */
  jd?: string

  /** 类别 */
  lb?: string

  /** 联系方式 */
  lxfs?: string

  /** 养殖场名称 */
  mc?: string

  /** 年生产能力（吨） */
  nscnl?: string

  /** 受纳水体 */
  snst?: string

  /** 所属街道 */
  szcj?: string

  /** 纬度 */
  wd?: string

  /** 养殖类型 */
  yzlx?: string

  /** 养殖面积（亩） */
  yzmj?: string

  /** 养殖种类 */
  yzzl?: string
}

export class ScyzDto {
  /** id */
  id?: string

  /** 经度 */
  jd?: string

  /** 名称 */
  mc?: string

  /** 年生产能力 */
  nscnl?: string

  /** 水体名称 */
  stmc?: string

  /** 纬度 */
  wd?: string

  /** 养殖面积 */
  yzmj?: string

  /** 养殖种类 */
  yzzl?: string

  /** 镇街地址 */
  zj?: string
}

export class SgAndAutoMonitorStatisticsQuery {
  /** 流域名称 */
  ly?: string

  /** month 格式 yyyy-MM */
  month?: string
}

export class SgDmPointByLyAndGkjbQuery {
  /** 流域名称 */
  ly?: string

  /** month 格式 yyyy-MM */
  month?: string

  /** 查询类型 */
  type?: string
}

export class SgDmPopVo {
  /** 标准水质类别的级别 */
  bzszlbdm?: number

  /** 断面名称 */
  dmmc?: string

  /** 检测时间 */
  jcsj?: string

  /** 最新水质参数 */
  quality?: DropBoxDto[]

  /** 水体类型 */
  stlx?: string

  /** 水质分析趋势数据 */
  waterTrendData?: WaterTrendDto[]

  /** 主要超标污染物 */
  zyCbWry?: string
}

export class SgDmSzpjStatisticsVo {
  /** 基准水质评价 */
  baseWaterLevel?: number

  /** 基准水质评价  罗马文+‘类’ */
  baseWaterLevelStr?: string

  /** 站点名称 */
  name?: string

  /** 水质评价  */
  waterLevel?: number

  /** 水质评价 罗马文+‘类’  */
  waterLevelStr?: string
}

export class SgMonitorHistoryCompareQuery {
  /** id */
  id?: string

  /** 年份 */
  year?: string
}

export class SgMonitorWaterQualityStatisticsQuery {
  /** 流域名称 */
  ly?: string

  /** 月份 时间格式（yyyy-MM） */
  month?: string

  /** 断面类型, （国控、市控、区县控） */
  sectionType?: string
}

export class SgdmWaterLevelDto {
  /** 年均评价水质结果 */
  avgYearPjjbn?: number

  /** 标准水质 */
  bzszlbdm?: number

  /** 出入境类型 */
  crjlx?: string

  /** 断面名称 */
  dmmc?: string

  /** 管控级别 */
  gkjb?: string

  /** 断面id */
  id?: string

  /** 监测时间 */
  jcsj?: string

  /** 经度 */
  jd?: string

  /** 评价水质 */
  pjjbn?: number

  /** 排序号 */
  pxh?: number

  /** 是否达标 */
  standard?: string

  /** 水体类型 */
  stlx?: string

  /** 纬度 */
  wd?: string
}

export class SgnqCountByLevelVo {
  /** 一级数量 */
  oneCount?: number

  /** 一级长度 */
  oneLevelLength?: number

  /** 二级数量 */
  twoCount?: number

  /** 二级长度 */
  twoLevelLength?: number
}

export class SgnqListVo {
  /** 功能区级别 */
  level?: string

  /** 水功能区名称 */
  name?: string

  /** 水质目标 罗马文 */
  szmb?: string

  /** 水质目标数字 */
  szmbn?: number
}

export class SgnqPieVo {
  /** 数量 */
  count?: number

  /** 长度 */
  length?: number

  /** 名称 */
  name?: string
}

export class SgnqWaterTargetVo {
  /** 一级功能区名称 */
  oneName?: string

  /** 水质目标罗马文 */
  szmb?: string

  /** 水质目标数字 */
  szmbn?: number

  /** 二级功能区名称 */
  twoName?: string
}

export class SkInfoDto {
  /** 坝型 */
  bx?: string
  dz?: string
  hkdm?: string

  /** 水库规模 */
  hkgm?: string

  /** 水库名称 */
  hkmc?: string
  id?: string

  /** 经度 */
  jd?: string

  /** 集雨面积 */
  jymj?: number

  /** 死库容 */
  skr?: number

  /** 所在河流 */
  stmc?: string

  /** 水库视频 */
  videoStream?: any[]

  /** 纬度 */
  wd?: string

  /** 现蓄库容(万m³) */
  xxkr?: number

  /** 现蓄水位(m) */
  xxsw?: number

  /** 所在乡镇 */
  xzqhmc?: string

  /** 正常库容 */
  zckr?: number

  /** 最大坝高 */
  zdbg?: string

  /** 总库容 */
  zkr?: number
}

export class SkInfoOverviewResDto {
  /** 小（1）型水库总数量 */
  'little1SkTotal'?: number

  /** 小（2）型水库总数量 */
  'little2SkTotal'?: number

  /** 中型水库总数量 */
  middleSkTotal?: number

  /** 水库总数量 */
  skTotal?: number

  /** 总库容 */
  skTotalCapacity?: number

  /** 饮用水源地数量 */
  yysydTotal?: number
}

export class StationListForMapModel {
  /** 坐标系 */
  coordinateSystem?: string

  /** 当前水质 */
  currentWaterQuality?: string

  /** 监测时间 */
  dataTime?: string

  /** 纬度 */
  latitude?: string

  /** 经度 */
  longitude?: string

  /** mn */
  mn?: string

  /** 断面名称 */
  sectionName?: string

  /** 设备状态 */
  status?: string

  /** 水质目标 */
  target?: string

  /** 站点类别（1.国控、2.市控、3.一体化站、4.物联站） */
  type?: string

  /** 镇街 */
  zj?: string
}

export class StatisticsCountDto {
  /** 数量 */
  count?: number

  /** 名称 */
  name?: string
}

export class StatisticsCountUnitDto {
  /** 数量 */
  count?: number

  /** 名称 */
  name?: string

  /** 单位 */
  unit?: string
}

export class SwMonitorRealTimeQuery {
  /** 流域名称 */
  ly?: string

  /** 数据时间 */
  time?: string

  /** 水文水利类型（水文站，水位站，雨量站） */
  zl?: string
}

export class SwSiteDetailAndGraphQuery {
  /** 站点编码 */
  indexCode?: string

  /** 时间 格式yyyy-MM-dd,不传默认查询最新数据 */
  time?: string
}

export class SwSiteStandardLineQuery {
  /** 年限 */
  ageLimit?: number

  /** 因子 */
  factor?: string

  /** 站点编码 */
  indexCode?: string
}

export class SwSiteStandardLineVo {
  /** 中位线 */
  medianLine?: number

  /** 七位线 */
  sevenLine?: number

  /** 三位线 */
  threeLine?: number
}

export class SwslGraphDto {
  /** 监测值 */
  d?: string

  /** 时点 */
  t?: string
}

export class SwslGraphVo {
  /** 对应因子的数据 */
  item?: SwslGraphDto[]

  /** 对应数据的的因子名称 */
  name?: string
}

export class SwslSiteInfo {
  /** 折线图所有数据 */
  datas?: SwslGraphVo[]

  /** 监测因子列表 */
  factors?: string[]

  /** 在线状态 */
  onlined?: boolean

  /** 测站编码 */
  stcd?: string

  /** 测站名称 */
  stnm?: string

  /** 测站类型 */
  type?: string
}

export class SwslSsjcDto {
  /** 站点编码 */
  indexCode?: string

  /** 站点名称 */
  indexName?: string

  /** 经度 */
  jd?: string

  /** 降雨量 */
  jyl?: string

  /** 流量 */
  ll?: string

  /** 水位 */
  sw?: string

  /** 时间 */
  tm?: string

  /** 纬度 */
  wd?: string
}

export class SwslZdtjDto {
  /** 水位站在线数 */
  swwzxs?: number

  /** 水位站总数 */
  swwzzs?: number

  /** 水文站总数 */
  swzzs?: number

  /** 水文站在线数 */
  swzzxs?: number

  /** 雨量站总数 */
  ylzzs?: number

  /** 雨量站在线数 */
  ylzzxs?: number
}

export class SzAndQgwtDetailDto {
  /** 千沟万塘详情 */
  qgwtDetails?: WaterMonitorAndThousandsDitchPondDto[]

  /** 水质详情 */
  szDetails?: WaterMonitorAndThousandsDitchPondDto[]
}

export class SzDetailDto {
  /** 监测对象 */
  dataList?: MonitorSubjectDto[]

  /** 监测时间 */
  dataTime?: string

  /** 因子列表 */
  factorList?: FactorSubjectDto[]

  /** 设备编码 */
  mn?: string

  /** 断面名称 */
  name?: string

  /** 主要污染物列表 */
  zywrwList?: SzZywrwDto[]
}

export class SzHistoryDto {
  /** 当前水质 */
  currentWaterQuality?: string

  /** 监测时点/时间 */
  dataTime?: string

  /** 经度 */
  jd?: number

  /** 设备编码 */
  mn?: string

  /** 断面名称 */
  sectionName?: string

  /** 水质目标 */
  target?: string

  /** 站点类型(1国控，2市控，3一体化，4物联站) */
  type?: string

  /** PH(无量纲) */
  'w01001'?: string

  /** PH异常标注 */
  'w01001Ex'?: string

  /** 浊度(NTU) */
  'w01003'?: string

  /** 浊度异常标注 */
  'w01003Ex'?: string

  /** 溶解氧(mg/L) */
  'w01009'?: string

  /** 溶解氧异常标注 */
  'w01009Ex'?: string

  /** 水温(℃) */
  'w01010'?: string

  /** 水温异常标注 */
  'w01010Ex'?: string

  /** 电导率(μS/cm) */
  'w01014'?: string

  /** 电导率异常标注 */
  'w01014Ex'?: string

  /** 化学需氧量(mg/L) */
  'w01018'?: string

  /** 化学需氧量异常标注 */
  'w01018Ex'?: string

  /** 高锰酸盐指数(mg/L) */
  'w01019'?: string

  /** 高锰酸盐指数异常标注 */
  'w01019Ex'?: string

  /** 总氮(mg/L) */
  'w21001'?: string

  /** 总氮异常标注 */
  'w21001Ex'?: string

  /** 氨氮(mg/L) */
  'w21003'?: string

  /** 氨氮异常标注 */
  'w21003Ex'?: string

  /** 总磷(mg/L) */
  'w21011'?: string

  /** 总磷异常标注 */
  'w21011Ex'?: string

  /** 纬度 */
  wd?: number
}

export class SzInfoDto {
  /** 工程地址 */
  dd?: string

  /** 工程类型 */
  gclx?: string

  /** id */
  id?: number

  /** 集雨面积 */
  jymj?: string

  /** 纬度 */
  lat?: string

  /** 经度 */
  lon?: string

  /** 联系电话 */
  lxfs?: string

  /** 联系人 */
  lxr?: string

  /** 所在河流 */
  szhl?: string

  /** 数据类型 1：拦河坝 2：'水闸 */
  type?: number

  /** 名称 */
  xmmc?: string

  /** 行政区划代码 */
  xzqhdm?: string

  /** 行政区划名称 */
  xzqhmc?: string

  /** 运营管理单位 */
  yxgldw?: string
}

export class SzInfoOverviewResDto {
  /** 船闸数量 */
  czTotal?: number

  /** 翻板闸数量 */
  fbzTotal?: number

  /** 滚水坝数量 */
  gsbTotal?: number

  /** 滚水坝（石）数量 */
  gsbsTotal?: number

  /** 石坝数量 */
  sbTotal?: number

  /** 水闸总数量 */
  szTotal?: number

  /** 条石坝数量 */
  tsbTotal?: number

  /** 橡胶坝数量 */
  xjbTotal?: number
}

export class SzZywrwDto {
  /** 超标倍数 */
  cbbs?: number

  /** 因子编码 */
  factorCode?: string

  /** 因子名称 */
  factorName?: string

  /** 监测值 */
  monitorValue?: number

  /** 标准值 */
  standValue?: number[]
}

export class TargetTaskCountStatisticsVo {
  qjCount?: number
  sjCount?: number
  totalCount?: number
  zjCount?: number
}

export class TargetTaskCountStatisticsVoChange {
  cxtjCount?: number
  totalCount?: number
}

export class TargetTaskEntity {
  /** 任务开始时间 */
  beginTime?: string

  /** 责任部门 */
  dutyDepartment?: string

  /** 任务结束时间 */
  endTime?: string

  /** id */
  id?: number

  /** 现状（2020年）指标值 */
  indicatorValueOne?: string

  /** 预期（2025年）指标值 */
  indicatorValueThree?: string

  /** 预期（2023年）指标值 */
  indicatorValueTwo?: string

  /** 主要指标 */
  primaryIndicator?: string

  /** 备注 */
  remake?: string

  /** 河长 */
  riverManager?: string

  /** 河流流域名称 */
  riverName?: string

  /** 具体任务 */
  specificTask?: string

  /** 任务级别 */
  taskLevel?: string

  /** 任务级别 */
  taskLevelStr?: string

  /** 目标任务类别 */
  taskType?: string

  /** 目标任务类别细分 */
  taskTypeSubdivide?: string

  /** 指标单位 */
  unit?: string
}

export class TargetTaskQuery {
  /** 开始时间 */
  beginTime?: string

  /** 结束时间 */
  endTime?: string

  /** 完成状态 */
  finish?: string

  /** 主要任务，责任部门 */
  keyword?: string

  /** 流域名称 */
  ly?: string

  /** 任务级别 1 市级 2 区级 3持续推进 */
  taskLevel?: string

  /** 类别 */
  type?: string
}

export class TitleModel {
  /** 因子编码 */
  identifier?: string

  /** 对应的中文名称 */
  name?: string

  /** 单位 */
  unit?: string
}

export class Type {
  typeName?: string
}

export class VideoListDto {
  /** 排口名称 */
  output?: string

  /** 站点名称 */
  psName?: string

  /** 视频地址 */
  videoPath?: string
}

export class WaterAssessmentDto {
  /** 当前数据月 */
  currentMonth?: string

  /** 国考 */
  gkDto?: WaterAssessmentGKDto

  /** 最新数据月 */
  month?: string

  /** 区考 */
  qkDto?: WaterAssessmentGKDto

  /** 市考 */
  skDto?: WaterAssessmentGKDto

  /** 物联站 */
  wlzDto?: WaterAssessmentGKDto

  /** 一体化 */
  ythDto?: WaterAssessmentGKDto
}

export class WaterAssessmentGKDto {
  /** 超标 */
  cb?: number

  /** 超标站点集合 */
  cbSitenames?: Record<string, any>[]

  /** 达标 */
  db?: number

  /** 达标站点集合 */
  dbSitenames?: Record<string, any>[]

  /** 总数 */
  total?: number

  /** 所有站点集合 */
  totalSitenames?: Record<string, any>[]
  wjc?: number
}

export class WaterAssessmentSectionInfoDto {
  /** 1-12月累计 */
  accumulativeWaterQuality?: string

  /** 考核结果 */
  assessmentResult?: string

  /** 当前水质 */
  currentWaterQuality?: string

  /** 经度 */
  jd?: string

  /** 排序号 */
  pxh?: number

  /** 断面ID */
  sectionID?: string

  /** 断面名称 */
  sectionName?: string

  /** 断面类型 */
  sectionType?: string

  /** 目标水质 */
  targetWaterQuality?: string

  /** 纬度 */
  wd?: string
}

export class WaterAssessmentSectionInfoResultDto {
  /** 当前数据月 */
  currentMonth?: string

  /** 最新数据月 */
  month?: string

  /** 断面总数 */
  sectionCount?: number

  /** 断面信息集合 */
  waterAssessmentSectionInfos?: WaterAssessmentSectionInfoDto[]
}

export class WaterMonitorAndThousandsDitchPondDto {
  /** 断面类型 */
  dmType?: string

  /** 河流名称 */
  hl?: string

  /** id */
  id?: number

  /** 经纬度 */
  jwd?: string

  /** 考核类别 */
  khType?: string

  /** 流域 */
  ly?: string

  /** 本月断面监测情况 */
  monitorCurrentMonth?: string

  /** 上月断面监测情况 */
  monitorLastMonth?: string

  /** 考核月份 */
  month?: string

  /** 监测点位置 */
  printAddress?: string

  /** 监测点编号 */
  printNo?: string

  /** 备注 */
  remark?: string

  /** 水质类别变化趋势 */
  trend?: string

  /** 考核镇街 */
  zj?: string
}

export class WaterPollutionEmissionStatisticsDto {
  /** 氨氮（吨） */
  adCapacity?: string

  /** COD（吨） */
  codCapacity?: string

  /** 污水处理量（吨） */
  fsCapacity?: string

  /** 总磷（吨） */
  zlCapacity?: string
}

export class WaterPollutionOnlineDto {
  /** 接入数量 */
  accessQuantity?: string

  /** 在线数-气泡展示数据 */
  itemModel?: WsclcStatisticalOnlineItemDto

  /** 在线监测总数 */
  monitorOnlineTotalQuantity?: number

  /** 离线数 */
  offlineQuantity?: number

  /** 在线率 */
  onlinePo?: string

  /** 在线数 */
  onlineQuantity?: number

  /** 超标数量 */
  overStandardQuantity?: string
}

export class WaterTrendDto {
  /** 因子 */
  code?: string

  /** 因子名称 */
  name?: string

  /** 趋势图 */
  trend?: string[]
  xaxis?: string[]
}

export class WgyCountStatisticsVo {
  /** 兼职网格员数量 */
  jzWgyCount?: number

  /** 网格员总数 */
  total?: number

  /** 专职网格员数量 */
  zzWgyCount?: number
}

export class WgyItemPrintDto {
  id?: number

  /** 经度 */
  jd?: string

  /** 纬度 */
  wd?: string

  /** 站点名称 */
  zdjgd?: string
}

export class WgyStatisticsVo {
  /** 兼职网格员数量 */
  jzWgyCount?: number

  /** 网格员 */
  riverWgy?: RiverLeaderTreeDto[]

  /** 网格员总数 */
  total?: number

  /** 专职网格员数量 */
  zzWgyCount?: number
}

export class WgyXhCountDto {
  /** 实际打卡次数 */
  sjdkCount?: number

  /** 实巡里程 */
  sxMileage?: number

  /** x轴数据 */
  xaxis?: string

  /** 应打卡次数 */
  ydkCount?: number

  /** 应巡里程 */
  yxMileage?: number
}

export class WgyXhCountInfoDto {
  /** 姓名 */
  name?: string

  /** 上报问题数量 */
  problemCount?: number

  /** 实际打卡次数 */
  sjdkCount?: number

  /** 实巡里程 */
  sxMileage?: number

  /** 网格员id */
  userId?: number

  /** 应打卡次数 */
  ydkCount?: number

  /** 应巡里程 */
  yxMileage?: number

  /** 镇街 */
  zj?: string
}

export class WgyXhDkProblemCountDto {
  /** 打卡完成率 */
  dkedRate?: string

  /** 上报问题数量 */
  problemCount?: number

  /** 处理完成数量 */
  resolvedCount?: number

  /** 问题处置完成率 */
  resolvedRate?: string

  /** 处理中数量 */
  resolvingCount?: number

  /** 实际打卡次数 */
  sjdkCount?: number

  /** 实巡里程 */
  sxMileage?: number

  /** 巡河完成率 */
  xhedRate?: string

  /** 正在巡河人数 */
  xhingCount?: number

  /** 应打卡次数 */
  ydkCount?: number

  /** 应巡里程 */
  yxMileage?: number

  /** 重点排口数量 */
  zdpkCount?: number
}

export class WgyXhGridByZjDto {
  /** 河流 */
  hl?: string

  /** mbId */
  id?: number

  /** 重点监管点 */
  prints?: string

  /** 起点名称 */
  qdmc?: string

  /** 用户id */
  userId?: number

  /** 用户名称 */
  username?: string

  /** 终点名称 */
  zdmc?: string
}

export class WgyXhGroupByZjDto {
  /** 百分比 */
  percent?: string

  /** 实巡数量 */
  sxCount?: number

  /** 应巡数量 */
  yxCount?: number

  /** 镇街 */
  zj?: string
}

export class WgyXhInfoStatisticsDto {
  /** 实巡次数 */
  sxQuantity?: number

  /** 所在镇街 */
  szzj?: string

  /** 网格员名称 */
  wgyName?: string

  /** 网格员id */
  wgyUserId?: number

  /** 应巡次数 */
  yxQuantity?: number
}

export class WgyZjMappingQuery {
  /** 搜索关键词 */
  keywords?: string

  /** 流域 */
  ly?: string

  /** 镇街 */
  zj?: string
}

export class WgyZjStatisticsVo {
  jzData?: number[]
  yaxis?: string[]
  zzData?: number[]
}

export class WorkflowRecordTreeDto {
  /** 指派时间 */
  assignTime?: string

  /** 指派时间Str */
  assignTimeStr?: string

  /** 指派人员 */
  assignUser?: string

  /** 子流程 */
  childList?: WorkflowRecordTreeDto[]

  /** 处理期限（单位：天） */
  deadline?: number

  /** 处理意见描述 */
  description?: string

  /** 评论列表 */
  evaluations?: WorkflowRecordTreeDto[]

  /** 附件列表 */
  fileList?: ZkProblemFileDto[]

  /** 流程描述 */
  flowDesc?: string

  /** 处理状态 1:待处理 2:处理中 3:已办结 */
  handleStatus?: number

  /** 处理状态 */
  handleStatusStr?: string

  /** 处理时间 */
  handleTime?: string

  /** 处理时间Str */
  handleTimeStr?: string

  /** 执行类型（1:执行/2:督办） */
  handleType?: number

  /** 执行类型 */
  handleTypeStr?: string

  /** 处理人员 */
  handleUser?: string

  /** id */
  id?: string

  /** 是否可以流程进行评价 */
  ifEvaluation?: boolean

  /** 是否合并单据（1是，0否） */
  merged?: number
  pid?: string

  /** 职务 */
  position?: string

  /** 职务全名 */
  positionFullName?: string

  /** 问题id */
  problemId?: string

  /** 处理进度 */
  schedule?: number

  /** 整改措施 */
  zgcs?: string

  /** 整改措施Str */
  zgcsStr?: string
}

export class WrjFlightRecordDto {
  /** 飞行时间 */
  createTime?: string

  /** 任务描述 */
  description?: string

  /** 飞行距离 */
  distance?: string

  /** 飞行结束点经度 */
  endJd?: string

  /** 终点名称 */
  endName?: string

  /** 飞行结束点纬度 */
  endWd?: string

  /** 飞行路径 */
  flightpath?: string

  /** id */
  id?: number

  /** 所属流域 */
  ly?: string

  /** 名称 */
  name?: string

  /** 河流名称 */
  river?: string

  /** 开始点经度 */
  startJd?: string

  /** 起点名称 */
  startName?: string

  /** 开始点纬度 */
  startWd?: string

  /** 飞行视频 */
  videoUrl?: string
}

export class WrjPathDto {
  /** 结束点经度 */
  endJd?: string

  /** 结束点纬度 */
  endWd?: string

  /** 飞行路径 */
  flightpath?: string

  /** id */
  id?: number

  /** 河流 */
  river?: string

  /** 开始点经度 */
  startJd?: string

  /** 开始点纬度 */
  startWd?: string
}

export class WrsyBoomListStatisticsVO {
  /** 报警次数 */
  boomCount?: number

  /** 报警时间 */
  boomTime?: string

  /** 报警类别 1:超标报警 2:突变报警 */
  boomType?: string

  /** 报警问题 */
  data?: HzddProblemListDto[]

  /** 问题描述 */
  problemDesc?: string
}

export class WrsyProblemQuery {
  /** 开始时间 */
  beginTime?: string

  /** 超标因子 */
  cbFactor?: string

  /** 重要程度 */
  emergencyDegree?: number

  /** 结束时间 */
  endTime?: string

  /** 经度 */
  jd?: number

  /** 河流点位 */
  points?: any[]

  /** 问题来源 */
  problemSource?: number

  /** 河道范围米数 */
  scope?: number

  /** 上游范围 */
  syfw?: number

  /** 纬度 */
  wd?: number

  /** 下游范围 */
  xyfw?: number
}

export class WrsyQuery {
  /** 开始时间 */
  beginTime?: string

  /** 超标因子 */
  cbFactor?: string

  /** 结束时间 */
  endTime?: string

  /** 河流点位 */
  points?: any[]

  /** 河道范围米数 */
  scope?: number
}

export class WrsyStatisticsDto {
  count?: number
  datas?: DotMapDto[]
  name?: string
}

export class WrsyStatisticsVo {
  /** 数量 */
  count?: number
  datas?: WrsyStatisticsDto[]

  /** 名称 */
  name?: string
}

export class WryHotMapQuery {
  /** 流域名称 */
  ly?: string
  no?: number
}

export class WryPreStatisticsVo {
  /** 区城管局 */
  cgj?: BasicDataStatisticsVo

  /** 区环保局 */
  hbj?: BasicDataStatisticsVo

  /** 区农委 */
  nw?: BasicDataStatisticsVo

  /** 区住建委 */
  zjw?: BasicDataStatisticsVo
}

export class WryStatisticsCountDto {
  /** 数量 */
  count?: number

  /** 名称 */
  name?: string
  no?: number
}

export class WsclcCbFactorDto {
  /** 报警值 */
  alarmValue?: string

  /** 因子 */
  factor?: string

  /** 超标百分比 */
  multiple?: string

  /** 报警时间 */
  time?: string
}

export class WsclcClickPointQuery {
  jr?: string

  /** 流域名称 */
  ly?: string
  online?: string
}

export class WsclcDetailDto {
  /** 地理位置 */
  address?: string

  /** 管控级别 */
  attentionDegreeCode?: string

  /** 责任单位 */
  epoName?: string

  /** 因子列表 */
  factors?: Record<string, string>[]

  /** 法人代表 */
  fddbr?: string

  /** 排口最新数据时间 */
  lastedDate?: string

  /** 排口编码 */
  outPutCode?: string

  /** 排口名称 */
  outPutName?: string

  /** 排放标准 */
  pfbz?: string

  /** 编码 */
  psCode?: string

  /** 污水处理厂名称 */
  psName?: string

  /** 排放去向类型 */
  psqxlx?: string

  /** 工艺 */
  ssclgy?: string

  /** 规模 */
  sssjrclnl?: string

  /** 水体名称 */
  stmc?: string

  /** 状态：cb / db / wsj / wjr */
  stru?: string

  /** 排污许可证编码 */
  tyshxydm?: string

  /** 污水处理厂视频 */
  videoList?: VideoListDto[]

  /** 运营单位 */
  yydwmc?: string
}

export class WsclcGraphDto {
  /** 时间 */
  dataTime?: string

  /** 因子 */
  factor?: string

  /** 监测时间 */
  monitorTime?: string

  /** 排口编码 */
  outPutCode?: string

  /** 标准值 */
  stand?: string[]

  /** 单位 */
  unit?: string

  /** 监测值 */
  value?: string
}

export class WsclcGraphQuery {
  /** 结束时间 yyyy-MM-dd HH */
  endTime?: string

  /** 监测因子 */
  factor?: string

  /** 排口编码 */
  outPutCode?: string

  /** 开始时间 yyyy-MM-dd HH */
  startTime?: string

  /**  hour:时均值, day:日均值 */
  type?: string
}

export class WsclcInfoItemsDto {
  /** 排口编码 */
  outPutCode?: string

  /** 排口名称 */
  outPutName?: string

  /** 排口状态 */
  stru?: string
}

export class WsclcInfoModel {
  /** 地理位置 */
  address?: string

  /** 设备启用状态： 0正常，1异常 */
  boomStatus?: number

  /** 处理能力等级1表示最大，4表示最小 */
  clLevel?: number

  /** 纬度 */
  latitude?: string

  /** 经度 */
  longitude?: string

  /** 排口列表 */
  outPuts?: WsclcInfoItemsDto[]

  /** 排放标准 */
  pfbz?: string

  /** 编码 */
  psCode?: string

  /** 污水处理厂名称 */
  psName?: string

  /** 接入状态：1接入， 0未接入 */
  sfazzxjc?: string

  /** 水体名称 */
  stmc?: string

  /** 超标状态：cb(超标) / db(达标) / wsj(无数据-离线) */
  stru?: string
}

export class WsclcPieClickPointQuery {
  /** 点击饼状图 文字 */
  condition?: string

  /** 流域名称 */
  ly?: string
}

export class WsclcStatisticalOnlineItemDto {
  /** 超标数 */
  cbQuantity?: number

  /** 达标率 */
  dbPo?: string

  /** 达标数 */
  dbQuantity?: number
}

export class XhFileDto {
  /** 描述 */
  des?: string

  /** 文件路径 */
  filePath?: string

  /** 文件类型 */
  fileType?: string

  /** 文件请求url */
  url?: string
}

export class XhGjInfoDto {
  /** 巡河附件 */
  files?: XhFileDto[]

  /** 巡河轨迹(k(经度),v(纬度)) */
  gjs?: any

  /** 责任人巡查分项详情id */
  id?: number

  /** 流域 */
  ly?: string

  /** 巡查频次 */
  pc?: string

  /** 起点经度 */
  qdjd?: string

  /** 起点名称 */
  qdmc?: string

  /** 起点纬度 */
  qdwd?: string

  /** 上报事件 */
  sbsjs?: XhSbsjDto[]

  /** 网格编号 */
  wgbh?: string

  /** 巡查范围 */
  xcfw?: string

  /** 巡查结论 */
  xhResult?: string

  /** 巡河对象 */
  xhdx?: XhdxDto

  /** 巡河结束时间 */
  xhjssj?: string

  /** 巡河开始时间 */
  xhkssj?: string

  /** 巡河状态：1巡河中，2巡河结束 */
  xhzt?: number

  /** 终点经度 */
  zdjd?: string

  /** 重点监管点列表 */
  zdjgds?: XhZdjgdDto[]

  /** 终点名称 */
  zdmc?: string

  /** 终点纬度 */
  zdwd?: string

  /** 联系人 */
  zrrUserName?: string

  /** 联系方式 */
  zrrUserTel?: string
}

export class XhIndexDto {
  /** 部门河长 */
  bmHz?: string

  /** 河长级别 */
  hzjb?: string

  /** 巡河记录id */
  id?: number

  /** 经度 */
  jd?: string

  /** 联系电话 */
  lxdh?: string

  /** 联系河段 */
  lxhd?: string

  /** 区级河长 */
  qjHz?: string

  /** 巡河人id */
  userId?: number

  /** 巡河人名称 */
  userName?: string

  /** 纬度 */
  wd?: string

  /** 镇街 */
  zj?: string

  /** 镇街河长 */
  zjHz?: string

  /** 职务 */
  zw?: string
}

export class XhSbsjDto {
  /** 经度 */
  jd?: string

  /** 事件名称 */
  sjmc?: string

  /** 事件uuid */
  uuid?: string

  /** 纬度 */
  wd?: string
}

export class XhZdjgdDto {
  /** 打卡状态: 1未打卡，2已打卡 */
  dkzt?: number

  /** 经度 */
  jd?: string

  /** 监测点类型：1重点监测点，2途径点 */
  type?: number

  /** 纬度 */
  wd?: string

  /** 监管点名称 */
  zdjgd?: string
}

export class XhdxDto {
  /** 上报事件数量 */
  sbsj?: number

  /** 巡查距离 */
  xcjl?: string

  /** 巡查时长 */
  xcsc?: string
}

export class XmyzDetailDto {
  ID?: string

  /** 曾用名 */
  cym?: string

  /** 地址 */
  dz?: string

  /** 粪便处理工艺 */
  fbClgy?: string

  /** 法人代表 */
  frdb?: string

  /** 经度 */
  jd?: number

  /** 联系方式 */
  lxfs?: string

  /** 名称 */
  mc?: string

  /** 圈舍清粪方式 */
  qsQffs?: string

  /** 圈舍通风方式 */
  qsTffs?: string

  /** 审核状态 */
  shzt?: any

  /** 设计存栏规模 */
  sjclgm?: any

  /** 纬度 */
  wd?: number

  /** 养殖种类 */
  yzzl?: string
}

export class XqyzDto {
  /** id */
  id?: string

  /** 经度 */
  jd?: string

  /** 名称 */
  mc?: string

  /** 设计存栏规模 */
  sjclgm?: string

  /** 设计年存栏规模 */
  sjnclgm?: string

  /** 纬度 */
  wd?: string

  /** 养殖种类 */
  yzzl?: string

  /** 镇街 */
  zj?: string
}

export class YcszStatistics {
  /** 十二个小时数据 */
  datas?: string[][]

  /** 时间轴 */
  dateAxis?: string[]

  /** 水质目标 */
  targetList?: string[]
  xaxis?: string[]
}

export class YdTsBasicDTO {
  /** 材质(联通线路) */
  cz?: string

  /** 工程编码 */
  gcbm?: string

  /** 工程备注 */
  gcbz?: any

  /** 工程名称 */
  gcmc?: string

  /** 工程终点 */
  gczd?: string

  /** geometry1 */
  'geometry1'?: string

  /** geometry2 */
  'geometry2'?: string

  /** 管径(联通线路) */
  gj?: any

  /** 联通线路 */
  ltxl?: string

  /** 设计取水量(联通线路) */
  sjqsl?: string
}

export class YdtsInfoOverviewResDto {
  /** 日常供水工程 */
  dailyTotal?: number

  /** 应急补水工程 */
  emergencyTotal?: number

  /** 总数量 */
  total?: number
}

export class YjpkCountStatisticsVO {
  /** 总数 */
  totalCount?: number

  /** 污水排口数量 */
  wspkCount?: number

  /** 雨水排口数量 */
  yspkCount?: number

  /** 雨污混流数量 */
  ywpkCount?: number
}

export class YysMonitorInfoDetailVo {
  /** 是否为保护区 true 是 false 否 */
  bhq?: boolean
  data?: WaterTrendDto[]

  /** 断面名称 */
  dmmc?: string

  /** 监测方式 */
  monitorFunc?: string

  /** 监测类型 */
  monitorType?: string
  nowSz?: string
  nowSzn?: number

  /** 水体类型 */
  stlx?: string

  /** 所在镇街 */
  szzj?: string
  targetSz?: string
  targetSzn?: number

  /** 饮用水源地类型 */
  yysydlx?: string

  /** 供水类型 */
  zdlx?: string
}

export class YysydCountStatisticsVo {
  /** 饼状图数据 */
  statisticsData?: CommonStatisticsDto[]

  /** 总数 */
  total?: number
}

export class YysydInfoStatisticsVo {
  /** 标准值(罗马文) */
  bzszlb?: string

  /** 标准值 */
  bzszlbdm?: number

  /** 断面名称 */
  dmmc?: string

  /** 断面id */
  id?: string

  /** 检测时间 */
  jcsj?: string

  /** 经度 */
  jd?: number

  /** 水质评价(罗马文 + '类')  */
  pjjb?: string

  /** 水质评价 */
  pjjbn?: number

  /** 超标状态, null为未知 */
  state?: boolean

  /** 纬度 */
  wd?: number

  /** 站点类型 */
  zdlx?: string
}

export class ZdgyqyLastDataDto {
  columns?: ParseMessageColumnDto[]
  data?: Record<string, any>[]
}

export class ZjProblemHandingRankingVO {
  /** 完成率 */
  finishRate?: number

  /** 已处理数 */
  overCount?: number

  /** 问题总数 */
  totalCount?: number

  /** zj */
  zj?: string
}

export class ZjQuery {
  /** 镇街名称 */
  zj?: string
}

export class ZjXhDkProblemCountDto {
  /** 打卡完成率 */
  dkedRate?: string

  /** 上报问题数量 */
  problemCount?: number

  /** 处理完成数量 */
  resolvedCount?: number

  /** 问题处置完成率 */
  resolvedRate?: string

  /** 处理中数量 */
  resolvingCount?: number

  /** 实际打卡次数 */
  sjdkCount?: number

  /** 实巡里程 */
  sxMileage?: number

  /** 网格员巡河统计 */
  wgyXhCountInfoDtos?: WgyXhCountInfoDto[]

  /** 巡河完成率 */
  xhedRate?: string

  /** 应打卡次数 */
  ydkCount?: number

  /** 应巡里程 */
  yxMileage?: number

  /** 重点排口数量 */
  zdpkCount?: number

  /** 网格员数量(专职) */
  zzwgyNum?: number
}

export class ZjxhCountStatisticsQuery {
  /** 流域名称 */
  ly?: string

  /** 频次, d, w, m, y */
  period?: string

  /** 是否完成巡河 全部，未完成，已完成 */
  xhwczt?: string

  /** 镇街名称 */
  zj?: string
}

export class ZkProblemFileDto {
  /** 文件名称 */
  fileName?: string

  /** 文件路径 */
  filePath?: string

  /** 文件类型(image,video,audio,doc,other) */
  fileType?: string

  /** 模块id（问题id/流程id） */
  modelId?: string
}

export class ZnzzVO {
  /** 职能职责 */
  content?: string

  /** 名称 */
  name?: string
}

export class ZxxdCountResDto {
  /** 分类 */
  category?: string

  /** 数量 */
  num?: string

  /** 完成数量 */
  resolvedNum?: string

  /** 完成率 */
  resolvedRate?: string
}

export class ZxxdInfoDto {
  /** 责任单位 */
  accountability?: string

  /** 类型 */
  category?: string

  /** 问题名称 */
  describe?: string

  /** 地址 */
  dz?: string

  /** 涉及河流 */
  hl?: string

  /** id */
  id?: number

  /** 经度 */
  jd?: number

  /** 牵头部门 */
  leadDepartment?: string

  /** 整改措施 */
  measure?: string

  /** 整改落实情况 */
  measureCondition?: string

  /** 计划完成时间 */
  planFinshTime?: string

  /** 计划完成时间Str */
  planFinshTimeStr?: string

  /** 问题领域 */
  problemNature?: string

  /** 备注 */
  remark?: string

  /** 完成情况（状态） */
  state?: string

  /** 纬度 */
  wd?: number
}

export class ZxxdQuery {
  /** 类型 */
  category?: string

  /** 结束年份 yyyy */
  endYear?: string

  /** id */
  id?: number

  /** 流域名称 */
  ly?: string

  /** 问题领域 */
  problemType?: string

  /** 起始年份 yyyy */
  startYear?: string
}

export class JsonResultAssessmentRankingsDto {
  code?: number
  data?: AssessmentRankingsDto
  msg?: string
}

export class JsonResultBasicDataListStatisticsVo {
  code?: number
  data?: BasicDataListStatisticsVo
  msg?: string
}

export class JsonResultCallInfoDto {
  code?: number
  data?: CallInfoDto
  msg?: string
}

export class JsonResultCameraStreamDto {
  code?: number
  data?: CameraStreamDto
  msg?: string
}

export class JsonResultCyqyEntity {
  code?: number
  data?: CyqyEntity
  msg?: string
}

export class JsonResultDfInfoOverviewResDto {
  code?: number
  data?: DfInfoOverviewResDto
  msg?: string
}

export class JsonResultDmYzDatumLine {
  code?: number
  data?: DmYzDatumLine
  msg?: string
}

export class JsonResultEventDetailDto {
  code?: number
  data?: EventDetailDto
  msg?: string
}

export class JsonResultGkSkWaterResDto {
  code?: number
  data?: GkSkWaterResDto
  msg?: string
}

export class JsonResultGridXcRecordBaseInfoDto {
  code?: number
  data?: GridXcRecordBaseInfoDto
  msg?: string
}

export class JsonResultGridXcRecordDto {
  code?: number
  data?: GridXcRecordDto
  msg?: string
}

export class JsonResultGscInfoOverviewResDto {
  code?: number
  data?: GscInfoOverviewResDto
  msg?: string
}

export class JsonResultGyqyInfoPopDto {
  code?: number
  data?: GyqyInfoPopDto
  msg?: string
}

export class JsonResultGyyqEntity {
  code?: number
  data?: GyyqEntity
  msg?: string
}

export class JsonResultGyyqInfoCountStatisticsVo {
  code?: number
  data?: GyyqInfoCountStatisticsVo
  msg?: string
}

export class JsonResultHkaxStatisticsVo {
  code?: number
  data?: HkaxStatisticsVo
  msg?: string
}

export class JsonResultHzCountStatisticsVo {
  code?: number
  data?: HzCountStatisticsVo
  msg?: string
}

export class JsonResultHzbProblemStatisticsDTO {
  code?: number
  data?: HzbProblemStatisticsDTO
  msg?: string
}

export class JsonResultHzxhCountStatisticsVo {
  code?: number
  data?: HzxhCountStatisticsVo
  msg?: string
}

export class JsonResultJgyStatisticsVO {
  code?: number
  data?: JgyStatisticsVO
  msg?: string
}

export class JsonResultLastDateTimeDTO {
  code?: number
  data?: LastDateTimeDTO
  msg?: string
}

export class JsonResultListAIListVo {
  code?: number
  data?: AIListVo[]
  msg?: string
}

export class JsonResultListAssessmentRankingsDto {
  code?: number
  data?: AssessmentRankingsDto[]
  msg?: string
}

export class JsonResultListCameraStreamDto {
  code?: number
  data?: CameraStreamDto[]
  msg?: string
}

export class JsonResultListCommonPointVo {
  code?: number
  data?: CommonPointVo[]
  msg?: string
}

export class JsonResultListCommonStatisticsDto {
  code?: number
  data?: CommonStatisticsDto[]
  msg?: string
}

export class JsonResultListCyqyEntity {
  code?: number
  data?: CyqyEntity[]
  msg?: string
}

export class JsonResultListDfBasicDTO {
  code?: number
  data?: DfBasicDTO[]
  msg?: string
}

export class JsonResultListDropBoxDto {
  code?: number
  data?: DropBoxDto[]
  msg?: string
}

export class JsonResultListDropBoxIntegerDto {
  code?: number
  data?: DropBoxIntegerDto[]
  msg?: string
}

export class JsonResultListDropDownDto {
  code?: number
  data?: DropDownDto[]
  msg?: string
}

export class JsonResultListDutyDepTargetTaskVo {
  code?: number
  data?: DutyDepTargetTaskVo[]
  msg?: string
}

export class JsonResultListGyyqInventoryVo {
  code?: number
  data?: GyyqInventoryVo[]
  msg?: string
}

export class JsonResultListHandleProblemListDTO {
  code?: number
  data?: HandleProblemListDTO[]
  msg?: string
}

export class JsonResultListHdhjEntity {
  code?: number
  data?: HdhjEntity[]
  msg?: string
}

export class JsonResultListHomeDropSelect {
  code?: number
  data?: HomeDropSelect[]
  msg?: string
}

export class JsonResultListHzddProblemListDto {
  code?: number
  data?: HzddProblemListDto[]
  msg?: string
}

export class JsonResultListHzlInfoDto {
  code?: number
  data?: HzlInfoDto[]
  msg?: string
}

export class JsonResultListJSONArray {
  code?: number
  data?: any[][]
  msg?: string
}

export class JsonResultListJSONObject {
  code?: number
  data?: Record<string, any>[]
  msg?: string
}

export class JsonResultListKeyTaskResolveEntity {
  code?: number
  data?: KeyTaskResolveEntity[]
  msg?: string
}

export class JsonResultListMapStringObject {
  code?: number
  data?: Record<string, any>[]
  msg?: string
}

export class JsonResultListMonitorDataListDto {
  code?: number
  data?: MonitorDataListDto[]
  msg?: string
}

export class JsonResultListMonitorVideoDto {
  code?: number
  data?: MonitorVideoDto[]
  msg?: string
}

export class JsonResultListNmscEntity {
  code?: number
  data?: NmscEntity[]
  msg?: string
}

export class JsonResultListOnlineWgyItemInfoDto {
  code?: number
  data?: OnlineWgyItemInfoDto[]
  msg?: string
}

export class JsonResultListPkListVo {
  code?: number
  data?: PkListVo[]
  msg?: string
}

export class JsonResultListProblemMeasuresDto {
  code?: number
  data?: ProblemMeasuresDto[]
  msg?: string
}

export class JsonResultListProblemMeasuresRateStatisticsDto {
  code?: number
  data?: ProblemMeasuresRateStatisticsDto[]
  msg?: string
}

export class JsonResultListProblemRecordDto {
  code?: number
  data?: ProblemRecordDto[]
  msg?: string
}

export class JsonResultListQskInfoDto {
  code?: number
  data?: QskInfoDto[]
  msg?: string
}

export class JsonResultListRankingsListDtos {
  code?: number
  data?: RankingsListDtos[]
  msg?: string
}

export class JsonResultListRiverCruiseDistrictRecordDto {
  code?: number
  data?: RiverCruiseDistrictRecordDto[]
  msg?: string
}

export class JsonResultListRiverCruiseRecordDto {
  code?: number
  data?: RiverCruiseRecordDto[]
  msg?: string
}

export class JsonResultListRiverInfoDto {
  code?: number
  data?: RiverInfoDto[]
  msg?: string
}

export class JsonResultListRiverLeaderTreeDto {
  code?: number
  data?: RiverLeaderTreeDto[]
  msg?: string
}

export class JsonResultListScyzDto {
  code?: number
  data?: ScyzDto[]
  msg?: string
}

export class JsonResultListSgDmSzpjStatisticsVo {
  code?: number
  data?: SgDmSzpjStatisticsVo[]
  msg?: string
}

export class JsonResultListSgdmWaterLevelDto {
  code?: number
  data?: SgdmWaterLevelDto[]
  msg?: string
}

export class JsonResultListSgnqListVo {
  code?: number
  data?: SgnqListVo[]
  msg?: string
}

export class JsonResultListSgnqPieVo {
  code?: number
  data?: SgnqPieVo[]
  msg?: string
}

export class JsonResultListSgnqWaterTargetVo {
  code?: number
  data?: SgnqWaterTargetVo[]
  msg?: string
}

export class JsonResultListSkInfoDto {
  code?: number
  data?: SkInfoDto[]
  msg?: string
}

export class JsonResultListStationListForMapModel {
  code?: number
  data?: StationListForMapModel[]
  msg?: string
}

export class JsonResultListStatisticsCountDto {
  code?: number
  data?: StatisticsCountDto[]
  msg?: string
}

export class JsonResultListStatisticsCountUnitDto {
  code?: number
  data?: StatisticsCountUnitDto[]
  msg?: string
}

export class JsonResultListSwslSsjcDto {
  code?: number
  data?: SwslSsjcDto[]
  msg?: string
}

export class JsonResultListSzHistoryDto {
  code?: number
  data?: SzHistoryDto[]
  msg?: string
}

export class JsonResultListSzInfoDto {
  code?: number
  data?: SzInfoDto[]
  msg?: string
}

export class JsonResultListTargetTaskEntity {
  code?: number
  data?: TargetTaskEntity[]
  msg?: string
}

export class JsonResultListWaterTrendDto {
  code?: number
  data?: WaterTrendDto[]
  msg?: string
}

export class JsonResultListWgyXhCountDto {
  code?: number
  data?: WgyXhCountDto[]
  msg?: string
}

export class JsonResultListWgyXhCountInfoDto {
  code?: number
  data?: WgyXhCountInfoDto[]
  msg?: string
}

export class JsonResultListWgyXhGridByZjDto {
  code?: number
  data?: WgyXhGridByZjDto[]
  msg?: string
}

export class JsonResultListWgyXhGroupByZjDto {
  code?: number
  data?: WgyXhGroupByZjDto[]
  msg?: string
}

export class JsonResultListWgyXhInfoStatisticsDto {
  code?: number
  data?: WgyXhInfoStatisticsDto[]
  msg?: string
}

export class JsonResultListWrjPathDto {
  code?: number
  data?: WrjPathDto[]
  msg?: string
}

export class JsonResultListWrsyBoomListStatisticsVO {
  code?: number
  data?: WrsyBoomListStatisticsVO[]
  msg?: string
}

export class JsonResultListWrsyStatisticsVo {
  code?: number
  data?: WrsyStatisticsVo[]
  msg?: string
}

export class JsonResultListWryStatisticsCountDto {
  code?: number
  data?: WryStatisticsCountDto[]
  msg?: string
}

export class JsonResultListWsclcCbFactorDto {
  code?: number
  data?: WsclcCbFactorDto[]
  msg?: string
}

export class JsonResultListWsclcGraphDto {
  code?: number
  data?: WsclcGraphDto[]
  msg?: string
}

export class JsonResultListWsclcInfoItemsDto {
  code?: number
  data?: WsclcInfoItemsDto[]
  msg?: string
}

export class JsonResultListWsclcInfoModel {
  code?: number
  data?: WsclcInfoModel[]
  msg?: string
}

export class JsonResultListXhIndexDto {
  code?: number
  data?: XhIndexDto[]
  msg?: string
}

export class JsonResultListXqyzDto {
  code?: number
  data?: XqyzDto[]
  msg?: string
}

export class JsonResultListYdTsBasicDTO {
  code?: number
  data?: YdTsBasicDTO[]
  msg?: string
}

export class JsonResultListYysydInfoStatisticsVo {
  code?: number
  data?: YysydInfoStatisticsVo[]
  msg?: string
}

export class JsonResultListZjProblemHandingRankingVO {
  code?: number
  data?: ZjProblemHandingRankingVO[]
  msg?: string
}

export class JsonResultListZnzzVO {
  code?: number
  data?: ZnzzVO[]
  msg?: string
}

export class JsonResultListZxxdCountResDto {
  code?: number
  data?: ZxxdCountResDto[]
  msg?: string
}

export class JsonResultListZxxdInfoDto {
  code?: number
  data?: ZxxdInfoDto[]
  msg?: string
}

export class JsonResultListString {
  code?: number
  data?: string[]
  msg?: string
}

export class JsonResultLygkCountStatisticsVo {
  code?: number
  data?: LygkCountStatisticsVo
  msg?: string
}

export class JsonResultMonitorDataGroupDto {
  code?: number
  data?: MonitorDataGroupDto
  msg?: string
}

export class JsonResultNmscEntity {
  code?: number
  data?: NmscEntity
  msg?: string
}

export class JsonResultPageListDfInfoDto {
  code?: number
  data?: PageListDfInfoDto
  msg?: string
}

export class JsonResultPageListGscInfoDto {
  code?: number
  data?: PageListGscInfoDto
  msg?: string
}

export class JsonResultPageListQskInfoDto {
  code?: number
  data?: PageListQskInfoDto
  msg?: string
}

export class JsonResultPageListSkInfoDto {
  code?: number
  data?: PageListSkInfoDto
  msg?: string
}

export class JsonResultPageListSzInfoDto {
  code?: number
  data?: PageListSzInfoDto
  msg?: string
}

export class JsonResultPkDetailDto {
  code?: number
  data?: PkDetailDto
  msg?: string
}

export class JsonResultProblemCountClassifiedStatisticsDTO {
  code?: number
  data?: ProblemCountClassifiedStatisticsDTO
  msg?: string
}

export class JsonResultProblemCountStatisticsDTO {
  code?: number
  data?: ProblemCountStatisticsDTO
  msg?: string
}

export class JsonResultQskInfoOverviewResDto {
  code?: number
  data?: QskInfoOverviewResDto
  msg?: string
}

export class JsonResultRankingTimesDto {
  code?: number
  data?: RankingTimesDto
  msg?: string
}

export class JsonResultRiverCruiseBaseStatisticsDto {
  code?: number
  data?: RiverCruiseBaseStatisticsDto
  msg?: string
}

export class JsonResultRiverLeaderStatisticsVo {
  code?: number
  data?: RiverLeaderStatisticsVo
  msg?: string
}

export class JsonResultScyzDetailDto {
  code?: number
  data?: ScyzDetailDto
  msg?: string
}

export class JsonResultSgDmPopVo {
  code?: number
  data?: SgDmPopVo
  msg?: string
}

export class JsonResultSgnqCountByLevelVo {
  code?: number
  data?: SgnqCountByLevelVo
  msg?: string
}

export class JsonResultSkInfoOverviewResDto {
  code?: number
  data?: SkInfoOverviewResDto
  msg?: string
}

export class JsonResultSwSiteStandardLineVo {
  code?: number
  data?: SwSiteStandardLineVo
  msg?: string
}

export class JsonResultSwslSiteInfo {
  code?: number
  data?: SwslSiteInfo
  msg?: string
}

export class JsonResultSwslZdtjDto {
  code?: number
  data?: SwslZdtjDto
  msg?: string
}

export class JsonResultSzAndQgwtDetailDto {
  code?: number
  data?: SzAndQgwtDetailDto
  msg?: string
}

export class JsonResultSzDetailDto {
  code?: number
  data?: SzDetailDto
  msg?: string
}

export class JsonResultSzInfoOverviewResDto {
  code?: number
  data?: SzInfoOverviewResDto
  msg?: string
}

export class JsonResultTargetTaskCountStatisticsVoChange {
  code?: number
  data?: TargetTaskCountStatisticsVoChange
  msg?: string
}

export class JsonResultTargetTaskCountStatisticsVo {
  code?: number
  data?: TargetTaskCountStatisticsVo
  msg?: string
}

export class JsonResultWaterAssessmentDto {
  code?: number
  data?: WaterAssessmentDto
  msg?: string
}

export class JsonResultWaterAssessmentSectionInfoResultDto {
  code?: number
  data?: WaterAssessmentSectionInfoResultDto
  msg?: string
}

export class JsonResultWaterPollutionEmissionStatisticsDto {
  code?: number
  data?: WaterPollutionEmissionStatisticsDto
  msg?: string
}

export class JsonResultWaterPollutionOnlineDto {
  code?: number
  data?: WaterPollutionOnlineDto
  msg?: string
}

export class JsonResultWgyCountStatisticsVo {
  code?: number
  data?: WgyCountStatisticsVo
  msg?: string
}

export class JsonResultWgyStatisticsVo {
  code?: number
  data?: WgyStatisticsVo
  msg?: string
}

export class JsonResultWgyXhDkProblemCountDto {
  code?: number
  data?: WgyXhDkProblemCountDto
  msg?: string
}

export class JsonResultWgyZjStatisticsVo {
  code?: number
  data?: WgyZjStatisticsVo
  msg?: string
}

export class JsonResultWrjFlightRecordDto {
  code?: number
  data?: WrjFlightRecordDto
  msg?: string
}

export class JsonResultWryPreStatisticsVo {
  code?: number
  data?: WryPreStatisticsVo
  msg?: string
}

export class JsonResultWsclcDetailDto {
  code?: number
  data?: WsclcDetailDto
  msg?: string
}

export class JsonResultXhGjInfoDto {
  code?: number
  data?: XhGjInfoDto
  msg?: string
}

export class JsonResultXmyzDetailDto {
  code?: number
  data?: XmyzDetailDto
  msg?: string
}

export class JsonResultYcszStatistics {
  code?: number
  data?: YcszStatistics
  msg?: string
}

export class JsonResultYdtsInfoOverviewResDto {
  code?: number
  data?: YdtsInfoOverviewResDto
  msg?: string
}

export class JsonResultYjpkCountStatisticsVO {
  code?: number
  data?: YjpkCountStatisticsVO
  msg?: string
}

export class JsonResultYysMonitorInfoDetailVo {
  code?: number
  data?: YysMonitorInfoDetailVo
  msg?: string
}

export class JsonResultYysydCountStatisticsVo {
  code?: number
  data?: YysydCountStatisticsVo
  msg?: string
}

export class JsonResultZdgyqyLastDataDto {
  code?: number
  data?: ZdgyqyLastDataDto
  msg?: string
}

export class JsonResultZjXhDkProblemCountDto {
  code?: number
  data?: ZjXhDkProblemCountDto
  msg?: string
}

export class JsonResultZxxdInfoDto {
  code?: number
  data?: ZxxdInfoDto
  msg?: string
}

export class JsonResultInt {
  code?: number
  data?: number
  msg?: string
}

export class JsonResultString {
  code?: number
  data?: string
  msg?: string
}

export class PageListDfInfoDto {
  /** 当前页相关数据 */
  items?: DfInfoDto[]

  /** 当前页 */
  page?: number

  /** 页面记录数/分页大小 */
  size?: number

  /** 总记录数 */
  totalCount?: number

  /** 总页数 */
  totalPages?: number
}

export class PageListGscInfoDto {
  /** 当前页相关数据 */
  items?: GscInfoDto[]

  /** 当前页 */
  page?: number

  /** 页面记录数/分页大小 */
  size?: number

  /** 总记录数 */
  totalCount?: number

  /** 总页数 */
  totalPages?: number
}

export class PageListQskInfoDto {
  /** 当前页相关数据 */
  items?: QskInfoDto[]

  /** 当前页 */
  page?: number

  /** 页面记录数/分页大小 */
  size?: number

  /** 总记录数 */
  totalCount?: number

  /** 总页数 */
  totalPages?: number
}

export class PageListSkInfoDto {
  /** 当前页相关数据 */
  items?: SkInfoDto[]

  /** 当前页 */
  page?: number

  /** 页面记录数/分页大小 */
  size?: number

  /** 总记录数 */
  totalCount?: number

  /** 总页数 */
  totalPages?: number
}

export class PageListSzInfoDto {
  /** 当前页相关数据 */
  items?: SzInfoDto[]

  /** 当前页 */
  page?: number

  /** 页面记录数/分页大小 */
  size?: number

  /** 总记录数 */
  totalCount?: number

  /** 总页数 */
  totalPages?: number
}

export class DTO {
  /** 开始或停止操作(0 开始 1 停止) */
  action?: number

  /** 所属设备编号（通用唯一识别码UUID） */
  cameraIndexCode?: string

  /** 控制命令(不区分大小写) LEFT 左转 RIGHT 右转 UP 上转 DOWN 下转 ZOOM_IN 焦距变大 ZOOM_OUT 焦距变小 LEFT_UP 左上 LEFT_DOWN 左下 RIGHT_UP 右上 RIGHT_DOWN 右下 FOCUS_NEAR 焦点前移 FOCUS_FAR 焦点后移 IRIS_ENLARGE 光圈扩大 IRIS_REDUCE 光圈缩小 以下命令presetIndex不可为空： GOTO_PRESET到预置点 */
  command?: string

  /** 预置点编号(取值范围为1-128) ，当command为GOTO_PRESET时需指定预置点编号 */
  presetIndex?: number

  /** 云台速度(取值范围为1-100，默认40) */
  speed?: number
}

/**
 * @title 环投网络流域公众服务平台接口文档
 * @version 2.2.0
 * @baseUrl //119.84.149.201/api/basin
 * 本文档描述了接口定义规范
 */
export class Api<SecurityDataType = any> extends ApiBase {
  openApi = {
    /**
     * No description
     *
     * @tags 对外开放接口
     * @name GetLastYearSgWaterTrendUsingPost
     * @summary 手工断面(含饮用水源地)最新一年的监测断面数据
     * @request POST:/openApi/screen/lastYearSgWaterTrend
     */
    getLastYearSgWaterTrendUsingPost: (
      query: IdStringQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListWaterTrendDto>(
        `/openApi/screen/lastYearSgWaterTrend`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 对外开放接口
     * @name GetYysMonitorDataPopUsingPost
     * @summary 饮用水源地--点位弹窗信息（含监测数据）
     * @request POST:/openApi/screen/yysMonitorDataPop
     */
    getYysMonitorDataPopUsingPost: (query: IdStringQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultYysMonitorInfoDetailVo>(
        `/openApi/screen/yysMonitorDataPop`,
        'POST',
        query,
        cancelToken
      ),
  }
  screen = {
    /**
     * No description
     *
     * @tags 河长大屏展示接口
     * @name CreateCallUsingPost
     * @summary 河长工作-创建视频房间
     * @request POST:/screen/callCreate
     */
    createCallUsingPost: (
      query?: { channelNo?: string; status?: number; userId?: number },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultString>(
        `/screen/callCreate${this.addQueryParams(query)}`,
        'POST',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 河长大屏展示接口
     * @name GetStatusUsingGet
     * @summary 根据房间号获取房间状态
     * @request GET:/screen/getStatus
     */
    getStatusUsingGet: (query: { channelNo: string }, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultCallInfoDto>(
        `/screen/getStatus${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 智慧河长大屏-首页
     * @name WgyWtInfoUsingGet
     * @summary 河长调度-问题详情(含处理流程)
     * @request GET:/screen/home/wgyWtInfo
     */
    wgyWtInfoUsingGet: (query: { id: string }, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultEventDetailDto>(
        `/screen/home/wgyWtInfo${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 智慧河长大屏-地图弹窗接口
     * @name GetAiListByIdUsingPost
     * @summary 获取监控摄像头关联的问题列表
     * @request POST:/screen/mapPop/aiListById
     */
    getAiListByIdUsingPost: (query: IdStringQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListAIListVo>(`/screen/mapPop/aiListById`, 'POST', query, cancelToken),

    /**
     * No description
     *
     * @tags 智慧河长大屏-地图弹窗接口
     * @name CameraControllingUsingPost
     * @summary 监测设备视频云台操作
     * @request POST:/screen/mapPop/cameraControlling
     */
    cameraControllingUsingPost: (
      query: CameraControllingQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultString>(
        `/screen/mapPop/cameraControlling`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 智慧河长大屏-地图弹窗接口
     * @name GetCameraStreamByIdUsingPost
     * @summary 监测设备视频流获取接口
     * @request POST:/screen/mapPop/cameraStreamById
     */
    getCameraStreamByIdUsingPost: (query: IdStringQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultCameraStreamDto>(
        `/screen/mapPop/cameraStreamById`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 智慧河长大屏-地图弹窗接口
     * @name GetCameraStreamListByIdUsingPost
     * @summary 监测设备视频流获取接口(多个返回值兼容枪球一体)
     * @request POST:/screen/mapPop/cameraStreamListById
     */
    getCameraStreamListByIdUsingPost: (
      query: IdStringQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListCameraStreamDto>(
        `/screen/mapPop/cameraStreamListById`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 智慧河长大屏-地图弹窗接口
     * @name CameraWsStreamByIdUsingPost
     * @summary 监测设备视频ws流获取
     * @request POST:/screen/mapPop/cameraWsStreamById
     */
    cameraWsStreamByIdUsingPost: (query: IdStringQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultCameraStreamDto>(
        `/screen/mapPop/cameraWsStreamById`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 智慧河长大屏-地图弹窗接口
     * @name GetCbFactorUsingGet
     * @summary 污染溯源--超标因子下拉
     * @request GET:/screen/mapPop/cbFactorDropDown
     */
    getCbFactorUsingGet: (cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListDropBoxDto>(
        `/screen/mapPop/cbFactorDropDown`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 智慧河长大屏-地图弹窗接口
     * @name GetMonitorDataListUsingGet
     * @summary 一体化自动站弹窗--监测数据
     * @request GET:/screen/mapPop/getAutoSiteMonitorDataList
     */
    getMonitorDataListUsingGet: (
      query: { begin: string; factor: string; frequency: string; mn: string },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListMonitorDataListDto>(
        `/screen/mapPop/getAutoSiteMonitorDataList${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 智慧河长大屏-地图弹窗接口
     * @name GetGyqyDetailUsingPost
     * @summary 工业企业弹窗
     * @request POST:/screen/mapPop/gyqyDetail
     */
    getGyqyDetailUsingPost: (query: IdStringQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultGyqyInfoPopDto>(
        `/screen/mapPop/gyqyDetail`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 智慧河长大屏-地图弹窗接口
     * @name GetScyzDetailUsingGet
     * @summary 水产养殖弹窗信息
     * @request GET:/screen/mapPop/scyzDetail
     */
    getScyzDetailUsingGet: (query?: { id?: string }, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultScyzDetailDto>(
        `/screen/mapPop/scyzDetail${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 智慧河长大屏-地图弹窗接口
     * @name DmyzDatumLineUsingGet
     * @summary 手工监测(水源地)断面弹窗信息-断面因子基准线
     * @request GET:/screen/mapPop/waterAssessment/dmyzDatumLine
     */
    dmyzDatumLineUsingGet: (
      query: { code: string; pjjbn: number; stlx: string },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultDmYzDatumLine>(
        `/screen/mapPop/waterAssessment/dmyzDatumLine${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 智慧河长大屏-地图弹窗接口
     * @name GetWrjFlightDetailByIdUsingGet
     * @summary 无人机飞行详情数据
     * @request GET:/screen/mapPop/wrjFlight
     */
    getWrjFlightDetailByIdUsingGet: (
      query?: { id?: number },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultWrjFlightRecordDto>(
        `/screen/mapPop/wrjFlight${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 智慧河长大屏-地图弹窗接口
     * @name GetWrsyPointListUsingPost
     * @summary 污染溯源--点位统计
     * @request POST:/screen/mapPop/wrsyPointList
     */
    getWrsyPointListUsingPost: (wrsyQuery: WrsyQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListWrsyStatisticsVo>(
        `/screen/mapPop/wrsyPointList`,
        'POST',
        wrsyQuery,
        cancelToken
      ),

    /**
     * @description 只查询上报问题
     *
     * @tags 智慧河长大屏-地图弹窗接口
     * @name GetWrsyProblemListUsingPost
     * @summary 污染溯源--问题列表
     * @request POST:/screen/mapPop/wrsyProblemList
     */
    getWrsyProblemListUsingPost: (
      wrsyProblemQuery: WrsyProblemQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListHzddProblemListDto>(
        `/screen/mapPop/wrsyProblemList`,
        'POST',
        wrsyProblemQuery,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 智慧河长大屏-地图弹窗接口
     * @name GetWrsyBoomListUsingPost
     * @summary 污染溯源--水质异常报警清单
     * @request POST:/screen/mapPop/wrsySzBoomList
     */
    getWrsyBoomListUsingPost: (
      wrsyProblemQuery: WrsyProblemQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListWrsyBoomListStatisticsVO>(
        `/screen/mapPop/wrsySzBoomList`,
        'POST',
        wrsyProblemQuery,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 智慧河长大屏-地图弹窗接口
     * @name GetWrsySzBoomListUsingPost
     * @summary 污染溯源--污染源异常报警清单
     * @request POST:/screen/mapPop/wrsyWryBoomList
     */
    getWrsySzBoomListUsingPost: (
      wrsyProblemQuery: WrsyProblemQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListWrsyBoomListStatisticsVO>(
        `/screen/mapPop/wrsyWryBoomList`,
        'POST',
        wrsyProblemQuery,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 智慧河长大屏-地图弹窗接口
     * @name WsclcCbFactorListUsingGet
     * @summary 污水处理厂超标因子数据弹窗信息
     * @request GET:/screen/mapPop/wsclcCbFactor
     */
    wsclcCbFactorListUsingGet: (
      query: { endTime: string; outPutCode: string; startTime: string; timeUnit?: string },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListWsclcCbFactorDto>(
        `/screen/mapPop/wsclcCbFactor${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 智慧河长大屏-地图弹窗接口
     * @name WsclcDetailInfoUsingGet
     * @summary 污水处理厂弹窗信息
     * @request GET:/screen/mapPop/wsclcDetail
     */
    wsclcDetailInfoUsingGet: (
      query: { outPutCode?: string; psCode: string; stmc?: string },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultWsclcDetailDto>(
        `/screen/mapPop/wsclcDetail${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 智慧河长大屏-地图弹窗接口
     * @name GetWsclcGraphListUsingPost
     * @summary 污水处理厂--监测数据折线图
     * @request POST:/screen/mapPop/wsclcGraphList
     */
    getWsclcGraphListUsingPost: (query: WsclcGraphQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListWsclcGraphDto>(
        `/screen/mapPop/wsclcGraphList`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 智慧河长大屏-地图弹窗接口
     * @name simulationDataGet
     * @summary 子流域弹窗信息
     * @request GET:/simulation-data/getSimulationData
     */
    simulationDataGet: (
      query: { target?: string; lyNo: number },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultWsclcDetailDto>(
        `/simulation-data/getSimulationData${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),
      
    /**
     * No description
     *
     * @tags 智慧河长大屏-地图弹窗接口(水文)
     * @name simulationDataGet
     * @summary 某些站点查询弹窗信息
     * @request GET:/shijudaping/station-detail
     */
    stationDetailGet: (
      query: { deviceId?: string; mn: string },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultWsclcDetailDto>(
        `/screen/shijudaping/station-detail${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),
    
    /**
     * No description
     *
     * @tags 智慧河长大屏-地图弹窗接口(水质)
     * @name simulationDataGet
     * @summary 某些站点查询弹窗信息
     * @request GET:/shijudaping/arealSourceByMn
     */
    arealSourceByMnGet: (
      query: { beginTime?: string; endTime?: string; factorName?: string; mn: string },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultWsclcDetailDto>(
        `/screen/shijudaping/arealSourceByMn${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),  

    /**
     * No description
     *
     * @tags 智慧河长大屏-地图弹窗接口
     * @name GetXmyzDetailUsingGet
     * @summary 畜牧养殖弹窗信息
     * @request GET:/screen/mapPop/xmyzDetail
     */
    getXmyzDetailUsingGet: (query?: { id?: string }, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultXmyzDetailDto>(
        `/screen/mapPop/xmyzDetail${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 河库岸线管理
     * @name GetAiListUsingPost
     * @summary AI视频问题清单
     * @request POST:/screen/v2.2/HkaxManager/aiList
     */
    getAiListUsingPost: (cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListAIListVo>(
        `/screen/v2.2/HkaxManager/aiList`,
        'POST',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 河库岸线管理
     * @name GetAiVideoClassifiedStatisticsUsingPost
     * @summary AI视频分类统计
     * @request POST:/screen/v2.2/HkaxManager/aiVideoClassifiedStatistics
     */
    getAiVideoClassifiedStatisticsUsingPost: (cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultProblemCountClassifiedStatisticsDTO>(
        `/screen/v2.2/HkaxManager/aiVideoClassifiedStatistics`,
        'POST',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 河库岸线管理
     * @name GetCameraStreamsUsingPost
     * @summary 摄像头视频流数据获取
     * @request POST:/screen/v2.2/HkaxManager/cameraStreams
     */
    getCameraStreamsUsingPost: (cameraIds: string[], cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListString>(
        `/screen/v2.2/HkaxManager/cameraStreams`,
        'POST',
        cameraIds,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 河库岸线管理
     * @name CameraYsyStreamsUsingPost
     * @summary 摄像头萤石云视频流获取
     * @request POST:/screen/v2.2/HkaxManager/cameraYsyStreams
     */
    cameraYsyStreamsUsingPost: (query: IdStringQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultCameraStreamDto>(
        `/screen/v2.2/HkaxManager/cameraYsyStreams`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 河库岸线管理
     * @name GetGnfqListUsingPost
     * @summary 功能分区--列表
     * @request POST:/screen/v2.2/HkaxManager/gnfqList
     */
    getGnfqListUsingPost: (query: GnfqQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListSgnqListVo>(
        `/screen/v2.2/HkaxManager/gnfqList`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 河库岸线管理
     * @name GetGnfqPieUsingPost
     * @summary 功能分区--饼状图
     * @request POST:/screen/v2.2/HkaxManager/gnfqPie
     */
    getGnfqPieUsingPost: (query: GnfqQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListSgnqPieVo>(
        `/screen/v2.2/HkaxManager/gnfqPie`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 河库岸线管理
     * @name GetGnfqStatisticsCountGroupByLevelUsingPost
     * @summary 功能分区--分级别统计总数长度
     * @request POST:/screen/v2.2/HkaxManager/gnfqStatisticsCountGroupByLevel
     */
    getGnfqStatisticsCountGroupByLevelUsingPost: (
      query: LyQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultSgnqCountByLevelVo>(
        `/screen/v2.2/HkaxManager/gnfqStatisticsCountGroupByLevel`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 河库岸线管理
     * @name GetHdhjListUsingPost
     * @summary 河道划界--数据列表
     * @request POST:/screen/v2.2/HkaxManager/hdhjList
     */
    getHdhjListUsingPost: (query: LyQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListHdhjEntity>(
        `/screen/v2.2/HkaxManager/hdhjList`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 河库岸线管理
     * @name GetHdhjStatisticsUsingPost
     * @summary 河道划界--数量统计
     * @request POST:/screen/v2.2/HkaxManager/hdhjStatistics
     */
    getHdhjStatisticsUsingPost: (query: LyQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultHkaxStatisticsVo>(
        `/screen/v2.2/HkaxManager/hdhjStatistics`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 河库岸线管理
     * @name GetMonitorVideoUsingPost
     * @summary 视频监控
     * @request POST:/screen/v2.2/HkaxManager/monitorVideo
     */
    getMonitorVideoUsingPost: (cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListMonitorVideoDto>(
        `/screen/v2.2/HkaxManager/monitorVideo`,
        'POST',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 基本概况
     * @name AiEventSubscribeUsingPost
     * @summary ai回调订阅
     * @request POST:/screen/v2.2/basic/aiEventSubscribe
     */
    aiEventSubscribeUsingPost: (post: AISubscriptionPost, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultString>(
        `/screen/v2.2/basic/aiEventSubscribe`,
        'POST',
        post,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 基本概况
     * @name AiEventUnSubscribeUsingPost
     * @summary ai回调取消订阅
     * @request POST:/screen/v2.2/basic/aiEventUNSubscribe
     */
    aiEventUnSubscribeUsingPost: (
      post: AISubscriptionPost,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultString>(
        `/screen/v2.2/basic/aiEventUNSubscribe`,
        'POST',
        post,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 基本概况
     * @name GetAutoSiteYcszByTwelveHourUsingPost
     * @summary 自动站水质评价(最新12小时内)
     * @request POST:/screen/v2.2/basic/autoSiteYcszByTwelveHour
     */
    getAutoSiteYcszByTwelveHourUsingPost: (query: LyQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultYcszStatistics>(
        `/screen/v2.2/basic/autoSiteYcszByTwelveHour`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * @description 通过点击基本情况数据查询点位数据
     *
     * @tags 基本概况
     * @name GetBasicClickPointListUsingPost
     * @summary 永川流域概况--点击基础数据获取点位
     * @request POST:/screen/v2.2/basic/basicClickPointList
     */
    getBasicClickPointListUsingPost: (
      query: BasicClickPointListQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListCommonPointVo>(
        `/screen/v2.2/basic/basicClickPointList`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 基本概况
     * @name GetBasicCountStatisticsUsingPost
     * @summary 永川流域概况--流域基本情况
     * @request POST:/screen/v2.2/basic/basicCountStatistics
     */
    getBasicCountStatisticsUsingPost: (
      query: BasicStatisticsQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultBasicDataListStatisticsVo>(
        `/screen/v2.2/basic/basicCountStatistics`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 基本概况
     * @name EventViewUsingPost
     * @summary ai回调订阅查询
     * @request POST:/screen/v2.2/basic/eventView
     */
    eventViewUsingPost: (cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultString>(`/screen/v2.2/basic/eventView`, 'POST', null, cancelToken),

    /**
     * No description
     *
     * @tags 基本概况
     * @name GetHlkgMainStatisticsUsingPost
     * @summary 河流概况统计--主要河流一览表
     * @request POST:/screen/v2.2/basic/hlkgMainRiverStatistics
     */
    getHlkgMainStatisticsUsingPost: (
      query: BasicStatisticsQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListRiverInfoDto>(
        `/screen/v2.2/basic/hlkgMainRiverStatistics`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 基本概况
     * @name GetHlkgStatisticsUsingPost
     * @summary 河流概况统计
     * @request POST:/screen/v2.2/basic/hlkgStatistics
     */
    getHlkgStatisticsUsingPost: (
      query: BasicStatisticsQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultLygkCountStatisticsVo>(
        `/screen/v2.2/basic/hlkgStatistics`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 基本概况
     * @name GetSgDmLastDateUsingPost
     * @summary 手工断面、自动站最新有时间数据
     * @request POST:/screen/v2.2/basic/sgAndAutoDataLastTime
     */
    getSgDmLastDateUsingPost: (cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultLastDateTimeDTO>(
        `/screen/v2.2/basic/sgAndAutoDataLastTime`,
        'POST',
        null,
        cancelToken
      ),

    /**
     * @description 断面水质评价
     *
     * @tags 基本概况
     * @name GetSgDmSzpjListByTimeUsingPost
     * @summary 手工断面沿程水质
     * @request POST:/screen/v2.2/basic/sgDmSzpjListByTime
     */
    getSgDmSzpjListByTimeUsingPost: (
      query: LyAndMonthQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListSgDmSzpjStatisticsVo>(
        `/screen/v2.2/basic/sgDmSzpjListByTime`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * @description 日d 周w 月m 年y
     *
     * @tags 公共接口
     * @name DatePeriodSelectUsingPost
     * @summary 时间周期接口
     * @request POST:/screen/v2.2/common/datePeriodSelect
     */
    datePeriodSelectUsingPost: (cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListDropBoxDto>(
        `/screen/v2.2/common/datePeriodSelect`,
        'POST',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 公共接口
     * @name EmergencyDegreeUsingPost
     * @summary 问题处置--紧急程度下拉
     * @request POST:/screen/v2.2/common/emergencyDegreeSelect
     */
    emergencyDegreeUsingPost: (cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListDropBoxDto>(
        `/screen/v2.2/common/emergencyDegreeSelect`,
        'POST',
        null,
        cancelToken
      ),

    /**
     * @description 包含所有流域
     *
     * @tags 公共接口
     * @name MapAreaSelectUsingPost
     * @summary 地图流域
     * @request POST:/screen/v2.2/common/mapAreaSelect
     */
    mapAreaSelectUsingPost: (cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListHomeDropSelect>(
        `/screen/v2.2/common/mapAreaSelect`,
        'POST',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 公共接口
     * @name PkTypeUsingPost
     * @summary 沿河排口--排口类别
     * @request POST:/screen/v2.2/common/pkType
     */
    pkTypeUsingPost: (cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListDropDownDto>(
        `/screen/v2.2/common/pkType`,
        'POST',
        null,
        cancelToken
      ),

    /**
     * @description 日d 周w 月m 年y 累积all
     *
     * @tags 公共接口
     * @name DateUsingPost
     * @summary 问题处置时间周期
     * @request POST:/screen/v2.2/common/problemDisposeDatePeriodSelect
     */
    dateUsingPost: (cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListDropBoxDto>(
        `/screen/v2.2/common/problemDisposeDatePeriodSelect`,
        'POST',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 公共接口
     * @name ProblemSubTypeUsingGet
     * @summary 问题列表--二级分类下拉
     * @request GET:/screen/v2.2/common/problemSubType
     */
    problemSubTypeUsingGet: (cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListDropBoxIntegerDto>(
        `/screen/v2.2/common/problemSubType`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 公共接口
     * @name ProblemTypeDropBoxUsingPost
     * @summary 问题列表-问题类别下拉
     * @request POST:/screen/v2.2/common/problemTypeSelect
     */
    problemTypeDropBoxUsingPost: (cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListDropDownDto>(
        `/screen/v2.2/common/problemTypeSelect`,
        'POST',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 河长履职管理
     * @name GetGridXcRecordBaseInfoDtoUsingPost
     * @summary 河长巡河--网格员在巡网格基础信息，参数传 itemId作为id
     * @request POST:/screen/v2.2/hzlzManager/gridXcRecordBaseInfoDto
     */
    getGridXcRecordBaseInfoDtoUsingPost: (query: IdDto, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultGridXcRecordBaseInfoDto>(
        `/screen/v2.2/hzlzManager/gridXcRecordBaseInfoDto`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 河长履职管理
     * @name GetGridXcRecordDtoUsingPost
     * @summary 河长巡河--网格员巡查记录
     * @request POST:/screen/v2.2/hzlzManager/gridXcRecordDto
     */
    getGridXcRecordDtoUsingPost: (
      query: GridWgyRecordQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultGridXcRecordDto>(
        `/screen/v2.2/hzlzManager/gridXcRecordDto`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 河长履职管理
     * @name GetHzAreaPatrolUsingPost
     * @summary 河长巡河-区域巡查
     * @request POST:/screen/v2.2/hzlzManager/hzAreaPatrol
     */
    getHzAreaPatrolUsingPost: (query: HzXhStatisticsQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListRiverCruiseDistrictRecordDto>(
        `/screen/v2.2/hzlzManager/hzAreaPatrol`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 河长履职管理
     * @name GetHzClickPopInfoUsingPost
     * @summary 一河一长--河长组织--河长点击弹窗
     * @request POST:/screen/v2.2/hzlzManager/hzClickPopInfo
     */
    getHzClickPopInfoUsingPost: (query: HzPopInfoQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListRiverLeaderTreeDto>(
        `/screen/v2.2/hzlzManager/hzClickPopInfo`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 河长履职管理
     * @name GetHzCountStatisticsUsingPost
     * @summary 一河一长--河长组织--河长人数统计
     * @request POST:/screen/v2.2/hzlzManager/hzCountStatistics
     */
    getHzCountStatisticsUsingPost: (query: LyAndZjQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultHzCountStatisticsVo>(
        `/screen/v2.2/hzlzManager/hzCountStatistics`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 河长履职管理
     * @name GetHzFunctionDutyUsingPost
     * @summary 一河一长--河长组织--职能职责
     * @request POST:/screen/v2.2/hzlzManager/hzFunctionDuty
     */
    getHzFunctionDutyUsingPost: (cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListZnzzVO>(
        `/screen/v2.2/hzlzManager/hzFunctionDuty`,
        'POST',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 河长履职管理
     * @name GetHzLevelDateDropBoxUsingPost
     * @summary 河长巡河-周期时间(行政级别级联下拉)
     * @request POST:/screen/v2.2/hzlzManager/hzLevelDateDropBox
     */
    getHzLevelDateDropBoxUsingPost: (
      query?: { type?: string },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListDropBoxDto>(
        `/screen/v2.2/hzlzManager/hzLevelDateDropBox${this.addQueryParams(query)}`,
        'POST',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 河长履职管理
     * @name GetHzLevelDropBoxUsingPost
     * @summary 巡河统计-行政级别下拉框
     * @request POST:/screen/v2.2/hzlzManager/hzLevelDropBox
     */
    getHzLevelDropBoxUsingPost: (cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListDropBoxDto>(
        `/screen/v2.2/hzlzManager/hzLevelDropBox`,
        'POST',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 河长履职管理
     * @name GetHzPeopleStatisticsUsingPost
     * @summary 一河一长--河长组织--弹窗信息
     * @request POST:/screen/v2.2/hzlzManager/hzPeopleStatistics
     */
    getHzPeopleStatisticsUsingPost: (query: LyAndZjQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultRiverLeaderStatisticsVo>(
        `/screen/v2.2/hzlzManager/hzPeopleStatistics`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 河长履职管理
     * @name GetHzXhRecordListUsingPost
     * @summary 河长巡河-巡查记录
     * @request POST:/screen/v2.2/hzlzManager/hzXhRecordList
     */
    getHzXhRecordListUsingPost: (query: HzXhRecordQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListRiverCruiseRecordDto>(
        `/screen/v2.2/hzlzManager/hzXhRecordList`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 河长履职管理
     * @name GetHzXhStatisticsUsingPost
     * @summary 河长巡河-基础信息统计
     * @request POST:/screen/v2.2/hzlzManager/hzXhStatistics
     */
    getHzXhStatisticsUsingPost: (
      query: HzXhStatisticsQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultRiverCruiseBaseStatisticsDto>(
        `/screen/v2.2/hzlzManager/hzXhStatistics`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 河长履职管理
     * @name GetHzbProblemHandleStatisticsUsingPost
     * @summary 河长办问题处置统计
     * @request POST:/screen/v2.2/hzlzManager/hzb/problemHandleStatistics
     */
    getHzbProblemHandleStatisticsUsingPost: (
      query: ZjxhCountStatisticsQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultHzbProblemStatisticsDTO>(
        `/screen/v2.2/hzlzManager/hzb/problemHandleStatistics`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 河长履职管理
     * @name HzlListUsingPost
     * @summary 专项行动--河长令列表
     * @request POST:/screen/v2.2/hzlzManager/hzlList
     */
    hzlListUsingPost: (qeqDto: HzlInfoQeqDto, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListHzlInfoDto>(
        `/screen/v2.2/hzlzManager/hzlList`,
        'POST',
        qeqDto,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 河长履职管理
     * @name GetHzxhCountStatisticsUsingPost
     * @summary 河长巡河--巡河情况数据统计
     * @request POST:/screen/v2.2/hzlzManager/hzxhCountStatistics
     */
    getHzxhCountStatisticsUsingPost: (
      query: HzxhCountStatisticsQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultHzxhCountStatisticsVo>(
        `/screen/v2.2/hzlzManager/hzxhCountStatistics`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 河长履职管理
     * @name JgyInfoStatisticsUsingPost
     * @summary 监管员人数，问题数统计
     * @request POST:/screen/v2.2/hzlzManager/jgy/infoStatistics
     */
    jgyInfoStatisticsUsingPost: (
      query: ZjxhCountStatisticsQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultJgyStatisticsVO>(
        `/screen/v2.2/hzlzManager/jgy/infoStatistics`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 河长履职管理
     * @name JgyProblemListUsingPost
     * @summary 监管员，上报问题
     * @request POST:/screen/v2.2/hzlzManager/jgy/problemList
     */
    jgyProblemListUsingPost: (
      query: ZjxhCountStatisticsQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListProblemRecordDto>(
        `/screen/v2.2/hzlzManager/jgy/problemList`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 河长履职管理
     * @name JgyProblemTypeStatisticsUsingPost
     * @summary 监管员，上报问题类型占比
     * @request POST:/screen/v2.2/hzlzManager/jgy/problemTypeStatistics
     */
    jgyProblemTypeStatisticsUsingPost: (
      query: ZjxhCountStatisticsQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListCommonStatisticsDto>(
        `/screen/v2.2/hzlzManager/jgy/problemTypeStatistics`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 河长履职管理
     * @name ListProblemTypeUsingPost
     * @summary 专项行动--问题分类
     * @request POST:/screen/v2.2/hzlzManager/listProblemType
     */
    listProblemTypeUsingPost: (cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListString>(
        `/screen/v2.2/hzlzManager/listProblemType`,
        'POST',
        null,
        cancelToken
      ),

    /**
     * @description 在线网格员
     *
     * @tags 河长履职管理
     * @name GetOnlineWgyUsingPost
     * @summary 正在巡河网格员
     * @request POST:/screen/v2.2/hzlzManager/onlineWgy
     */
    getOnlineWgyUsingPost: (query: LyQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListXhIndexDto>(
        `/screen/v2.2/hzlzManager/onlineWgy`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 河长履职管理
     * @name GetOnlineWgyItemInfoUsingPost
     * @summary 河长巡河--正在巡河网格员基础信息，以及实时轨迹
     * @request POST:/screen/v2.2/hzlzManager/onlineWgyItemInfo
     */
    getOnlineWgyItemInfoUsingPost: (query: LyQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListOnlineWgyItemInfoDto>(
        `/screen/v2.2/hzlzManager/onlineWgyItemInfo`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 河长履职管理
     * @name OtherItemProblemListUsingPost
     * @summary 其他巡查，问题清单
     * @request POST:/screen/v2.2/hzlzManager/otherItem/problemList
     */
    otherItemProblemListUsingPost: (
      query: ZjxhCountStatisticsQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListHandleProblemListDTO>(
        `/screen/v2.2/hzlzManager/otherItem/problemList`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 河长履职管理
     * @name GetOverProblemHotMapUsingPost
     * @summary 问题处置--处置问题热力图
     * @request POST:/screen/v2.2/hzlzManager/overProblemHotMap
     */
    getOverProblemHotMapUsingPost: (
      query: HzxhCountStatisticsQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListJSONArray>(
        `/screen/v2.2/hzlzManager/overProblemHotMap`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 河长履职管理
     * @name PmtimeUsingGet
     * @summary 镇街考核-获取考核排名最新时间
     * @request GET:/screen/v2.2/hzlzManager/pmtime
     */
    pmtimeUsingGet: (cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultRankingTimesDto>(
        `/screen/v2.2/hzlzManager/pmtime`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 河长履职管理
     * @name GetProblemCountClassifiedStatisticsUsingPost
     * @summary 问题处置情况--问题分类统计(饼状图)
     * @request POST:/screen/v2.2/hzlzManager/problemCountClassifiedStatistics
     */
    getProblemCountClassifiedStatisticsUsingPost: (
      query: HzxhCountStatisticsQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultProblemCountClassifiedStatisticsDTO>(
        `/screen/v2.2/hzlzManager/problemCountClassifiedStatistics`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 河长履职管理
     * @name GetProblemCountStatisticsUsingPost
     * @summary 问题处置情况--问题总数统计
     * @request POST:/screen/v2.2/hzlzManager/problemCountStatistics
     */
    getProblemCountStatisticsUsingPost: (
      query: HzxhCountStatisticsQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultProblemCountStatisticsDTO>(
        `/screen/v2.2/hzlzManager/problemCountStatistics`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 河长履职管理
     * @name GetProblemListUsingPost
     * @summary 问题处置情况--问题列表
     * @request POST:/screen/v2.2/hzlzManager/problemList
     */
    getProblemListUsingPost: (query: HzxhProblemListQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListHzddProblemListDto>(
        `/screen/v2.2/hzlzManager/problemList`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 河长履职管理
     * @name GetProblemSubTypeCountStatisticsUsingPost
     * @summary 问题处置情况--二级问题分类(饼状图)
     * @request POST:/screen/v2.2/hzlzManager/problemSubTypeCountStatistics
     */
    getProblemSubTypeCountStatisticsUsingPost: (
      query: HzxhCountStatisticsQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListCommonStatisticsDto>(
        `/screen/v2.2/hzlzManager/problemSubTypeCountStatistics`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 河长履职管理
     * @name ProjectProblemStatisticsUsingPost
     * @summary 项目公司，问题数统计
     * @request POST:/screen/v2.2/hzlzManager/project/problemStatistics
     */
    projectProblemStatisticsUsingPost: (
      query: ZjxhCountStatisticsQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultJgyStatisticsVO>(
        `/screen/v2.2/hzlzManager/project/problemStatistics`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 河长履职管理
     * @name GetTargetTaskCountUsingPost
     * @summary 一河一策--目标任务--数量统计
     * @request POST:/screen/v2.2/hzlzManager/targetTaskCount
     */
    getTargetTaskCountUsingPost: (query: TargetTaskQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultTargetTaskCountStatisticsVo>(
        `/screen/v2.2/hzlzManager/targetTaskCount`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 河长履职管理
     * @name GetTargetTaskDetailListUsingPost
     * @summary 一河一策--目标任务--目标任务清单--详情版
     * @request POST:/screen/v2.2/hzlzManager/targetTaskDetailList
     */
    getTargetTaskDetailListUsingPost: (
      query: TargetTaskQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListTargetTaskEntity>(
        `/screen/v2.2/hzlzManager/targetTaskDetailList`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 河长履职管理
     * @name GetTargetTaskListUsingPost
     * @summary 一河一策--目标任务--目标任务清单
     * @request POST:/screen/v2.2/hzlzManager/targetTaskList
     */
    getTargetTaskListUsingPost: (query: TargetTaskQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListDutyDepTargetTaskVo>(
        `/screen/v2.2/hzlzManager/targetTaskList`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 河长履职管理
     * @name GetTargetTaskStatisticsUsingPost
     * @summary 一河一策--目标任务--饼状图
     * @request POST:/screen/v2.2/hzlzManager/targetTaskPie
     */
    getTargetTaskStatisticsUsingPost: (
      query: TargetTaskQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListStatisticsCountDto>(
        `/screen/v2.2/hzlzManager/targetTaskPie`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 河长履职管理
     * @name GetTargetTaskTypeDropdownUsingPost
     * @summary 一河一策--目标任务清单--分类下拉
     * @request POST:/screen/v2.2/hzlzManager/targetTaskTypeDropdown
     */
    getTargetTaskTypeDropdownUsingPost: (cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListDropBoxDto>(
        `/screen/v2.2/hzlzManager/targetTaskTypeDropdown`,
        'POST',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 河长履职管理
     * @name GetTaskFjCountUsingPost
     * @summary 一河一策--分解任务数量统计
     * @request POST:/screen/v2.2/hzlzManager/taskFjCount
     */
    getTaskFjCountUsingPost: (query: TargetTaskQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultTargetTaskCountStatisticsVoChange>(
        `/screen/v2.2/hzlzManager/taskFjCount`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 河长履职管理
     * @name GetTaskFjDetailListUsingPost
     * @summary 一河一策--任务分解清单--详情版
     * @request POST:/screen/v2.2/hzlzManager/taskFjDetailList
     */
    getTaskFjDetailListUsingPost: (query: TargetTaskQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListKeyTaskResolveEntity>(
        `/screen/v2.2/hzlzManager/taskFjDetailList`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 河长履职管理
     * @name GetTaskFjListUsingPost
     * @summary 一河一策--任务分解清单
     * @request POST:/screen/v2.2/hzlzManager/taskFjList
     */
    getTaskFjListUsingPost: (query: TargetTaskQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListProblemMeasuresDto>(
        `/screen/v2.2/hzlzManager/taskFjList`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 河长履职管理
     * @name GetTaskFjStatisticsUsingPost
     * @summary 一河一策--分解任务饼状图
     * @request POST:/screen/v2.2/hzlzManager/taskFjPie
     */
    getTaskFjStatisticsUsingPost: (query: TargetTaskQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListProblemMeasuresRateStatisticsDto>(
        `/screen/v2.2/hzlzManager/taskFjPie`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 河长履职管理
     * @name TaskFjStatusDropdownUsingPost
     * @summary 一河一策--任务分解清单--任务状态下拉
     * @request POST:/screen/v2.2/hzlzManager/taskFjStatusDropdown
     */
    taskFjStatusDropdownUsingPost: (cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListDropBoxDto>(
        `/screen/v2.2/hzlzManager/taskFjStatusDropdown`,
        'POST',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 河长履职管理
     * @name GetTaskFjTypeDropdownUsingPost
     * @summary 一河一策--任务分解清单--分类下拉
     * @request POST:/screen/v2.2/hzlzManager/taskFjTypeDropdown
     */
    getTaskFjTypeDropdownUsingPost: (cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListDropBoxDto>(
        `/screen/v2.2/hzlzManager/taskFjTypeDropdown`,
        'POST',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 河长履职管理
     * @name GetUpProblemHotUsingPost
     * @summary 问题处置--上报问题热力图
     * @request POST:/screen/v2.2/hzlzManager/upProblemHotMap
     */
    getUpProblemHotUsingPost: (
      query: HzxhCountStatisticsQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListJSONArray>(
        `/screen/v2.2/hzlzManager/upProblemHotMap`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 河长履职管理
     * @name GetWgyCountStatisticsUsingPost
     * @summary 一河一长--网格员数量统计
     * @request POST:/screen/v2.2/hzlzManager/wgyCountStatistics
     */
    getWgyCountStatisticsUsingPost: (query: LyAndZjQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultWgyCountStatisticsVo>(
        `/screen/v2.2/hzlzManager/wgyCountStatistics`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 河长履职管理
     * @name GetWgyFunctionDutyUsingPost
     * @summary 一河一长--网格员组织--职能职责
     * @request POST:/screen/v2.2/hzlzManager/wgyFunctionDuty
     */
    getWgyFunctionDutyUsingPost: (cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListString>(
        `/screen/v2.2/hzlzManager/wgyFunctionDuty`,
        'POST',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 河长履职管理
     * @name GetWgyOnlineCountUsingPost
     * @summary 河长巡河--在线巡河人数
     * @request POST:/screen/v2.2/hzlzManager/wgyOnlineCount
     */
    getWgyOnlineCountUsingPost: (query: LyQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultInt>(
        `/screen/v2.2/hzlzManager/wgyOnlineCount`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 河长履职管理
     * @name GetWgyStatisticsVoUsingPost
     * @summary 一河一长--网格员组织--弹窗信息
     * @request POST:/screen/v2.2/hzlzManager/wgyStatistics
     */
    getWgyStatisticsVoUsingPost: (query: LyAndZjQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultWgyStatisticsVo>(
        `/screen/v2.2/hzlzManager/wgyStatistics`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 河长履职管理
     * @name GetWgyUnXhInfoStatisticsDtoUsingPost
     * @summary 河长巡河--未完成巡河列表
     * @request POST:/screen/v2.2/hzlzManager/wgyUnXhInfoStatisticsDto
     */
    getWgyUnXhInfoStatisticsDtoUsingPost: (
      query: HzxhCountStatisticsQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListWgyXhInfoStatisticsDto>(
        `/screen/v2.2/hzlzManager/wgyUnXhInfoStatisticsDto`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 河长履职管理
     * @name WgyXhCountByZjUsingPost
     * @summary 网格员--巡河，巡河完成情况
     * @request POST:/screen/v2.2/hzlzManager/wgyXhCountByZj
     */
    wgyXhCountByZjUsingPost: (
      query: HzxhCountStatisticsQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListWgyXhCountDto>(
        `/screen/v2.2/hzlzManager/wgyXhCountByZj`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 河长履职管理
     * @name WgyXhDkProblemCountUsingPost
     * @summary 网格员--巡河，打卡，问题处置统计
     * @request POST:/screen/v2.2/hzlzManager/wgyXhDkProblemCount
     */
    wgyXhDkProblemCountUsingPost: (
      query: HzxhCountStatisticsQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultWgyXhDkProblemCountDto>(
        `/screen/v2.2/hzlzManager/wgyXhDkProblemCount`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * @description 查询镇街对应网格员，以及网格员的重点监管点等信息
     *
     * @tags 河长履职管理
     * @name GetWgyXhGridByZjUsingPost
     * @summary 一河一长--查询行政区划网格员信息
     * @request POST:/screen/v2.2/hzlzManager/wgyXhGridByZj
     */
    getWgyXhGridByZjUsingPost: (query: ZjQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListWgyXhGridByZjDto>(
        `/screen/v2.2/hzlzManager/wgyXhGridByZj`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 河长履职管理
     * @name GetWgyXhGroupByZjUsingPost
     * @summary 河长巡河--区域巡查情况统计图
     * @request POST:/screen/v2.2/hzlzManager/wgyXhGroupByZj
     */
    getWgyXhGroupByZjUsingPost: (
      query: HzxhCountStatisticsQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListWgyXhGroupByZjDto>(
        `/screen/v2.2/hzlzManager/wgyXhGroupByZj`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 河长履职管理
     * @name WgyXhInfoUsingPost
     * @summary 网格员--巡河清单
     * @request POST:/screen/v2.2/hzlzManager/wgyXhInfo
     */
    wgyXhInfoUsingPost: (query: HzxhCountStatisticsQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListWgyXhCountInfoDto>(
        `/screen/v2.2/hzlzManager/wgyXhInfo`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 河长履职管理
     * @name GetWgyXhRecordDetailUsingGet
     * @summary 河长巡河--网格员巡查记录详情
     * @request GET:/screen/v2.2/hzlzManager/wgyXhRecordDetail
     */
    getWgyXhRecordDetailUsingGet: (
      query?: { id?: number },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultXhGjInfoDto>(
        `/screen/v2.2/hzlzManager/wgyXhRecordDetail${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 河长履职管理
     * @name GetWgyXhTrackUsingPost
     * @summary 河长巡河--巡河情况热力图
     * @request POST:/screen/v2.2/hzlzManager/wgyXhTrack
     */
    getWgyXhTrackUsingPost: (
      query: HzxhCountStatisticsQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListJSONArray>(
        `/screen/v2.2/hzlzManager/wgyXhTrack`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 河长履职管理
     * @name GetWgyZjMappingCountStatisticsUsingPost
     * @summary 一河一长--网格员镇街分布统计
     * @request POST:/screen/v2.2/hzlzManager/wgyZjMappingCountStatistics
     */
    getWgyZjMappingCountStatisticsUsingPost: (
      query: WgyZjMappingQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultWgyZjStatisticsVo>(
        `/screen/v2.2/hzlzManager/wgyZjMappingCountStatistics`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 河长履职管理
     * @name GetZjProblemFinishRateSortStatisticsUsingPost
     * @summary 问题处置情况--镇街处置排名
     * @request POST:/screen/v2.2/hzlzManager/zjProblemFinishRateSortStatistics
     */
    getZjProblemFinishRateSortStatisticsUsingPost: (
      query: HzxhCountStatisticsQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListZjProblemHandingRankingVO>(
        `/screen/v2.2/hzlzManager/zjProblemFinishRateSortStatistics`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 河长履职管理
     * @name ZjXhCountUsingPost
     * @summary 镇街巡河情况统计
     * @request POST:/screen/v2.2/hzlzManager/zjXhCount
     */
    zjXhCountUsingPost: (query: ZjxhCountStatisticsQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultZjXhDkProblemCountDto>(
        `/screen/v2.2/hzlzManager/zjXhCount`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 河长履职管理
     * @name ZxxdCountUsingPost
     * @summary 专项行动--数量统计
     * @request POST:/screen/v2.2/hzlzManager/zxxdCount
     */
    zxxdCountUsingPost: (query: ZxxdQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListZxxdCountResDto>(
        `/screen/v2.2/hzlzManager/zxxdCount`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 河长履职管理
     * @name ZxxdDetailUsingPost
     * @summary 专项行动--某问题详情
     * @request POST:/screen/v2.2/hzlzManager/zxxdDetail
     */
    zxxdDetailUsingPost: (query: IdIntegerQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultZxxdInfoDto>(
        `/screen/v2.2/hzlzManager/zxxdDetail`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 河长履职管理
     * @name ZxxdListUsingPost
     * @summary 专项行动--数据类型列表
     * @request POST:/screen/v2.2/hzlzManager/zxxdList
     */
    zxxdListUsingPost: (query: ZxxdQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListZxxdInfoDto>(
        `/screen/v2.2/hzlzManager/zxxdList`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 河长履职管理
     * @name GetZxxdPointUsingPost
     * @summary 专项行动--点位
     * @request POST:/screen/v2.2/hzlzManager/zxxdPoint
     */
    getZxxdPointUsingPost: (query: LyQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListCommonPointVo>(
        `/screen/v2.2/hzlzManager/zxxdPoint`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 视频监控点控制层
     * @name ControllingUsingPost
     * @summary 操作摄像头
     * @request POST:/screen/v2.2/monitorVideo/controlling
     */
    controllingUsingPost: (commandDTO: DTO, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResult>(
        `/screen/v2.2/monitorVideo/controlling`,
        'POST',
        commandDTO,
        cancelToken
      ),

    /**
     * @description 用于地图河流颜色渲染
     *
     * @tags 水环境管理
     * @name GetAutoSiteLastWaterLevelUsingPost
     * @summary 自动站点最新水质评价
     * @request POST:/screen/v2.2/waterEnvManager/autoSiteLastWaterLevel
     */
    getAutoSiteLastWaterLevelUsingPost: (query: LyQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListStationListForMapModel>(
        `/screen/v2.2/waterEnvManager/autoSiteLastWaterLevel`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水环境管理
     * @name GetAutoSitePointByLyAndGkjbUsingPost
     * @summary 自动站点位获取
     * @request POST:/screen/v2.2/waterEnvManager/autoSitePoint
     */
    getAutoSitePointByLyAndGkjbUsingPost: (
      query: AutoSitePointByLyAndGkjbQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListCommonPointVo>(
        `/screen/v2.2/waterEnvManager/autoSitePoint`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水环境管理
     * @name GetAutoSiteStatisticsUsingPost
     * @summary 自动站总数,达标统计
     * @request POST:/screen/v2.2/waterEnvManager/autoSiteStatistics
     */
    getAutoSiteStatisticsUsingPost: (
      query: SgAndAutoMonitorStatisticsQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultWaterAssessmentDto>(
        `/screen/v2.2/waterEnvManager/autoSiteStatistics`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水环境管理
     * @name GetAutoSiteSzskUsingPost
     * @summary 水质实况
     * @request POST:/screen/v2.2/waterEnvManager/autoSiteSzsk
     */
    getAutoSiteSzskUsingPost: (query: AutoSiteSzskQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListSzHistoryDto>(
        `/screen/v2.2/waterEnvManager/autoSiteSzsk`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水环境管理
     * @name GetDmYzDatumLineUsingPost
     * @summary 手工监测(水源地)断面弹窗信息-断面因子基准线
     * @request POST:/screen/v2.2/waterEnvManager/dmYzDatumLine
     */
    getDmYzDatumLineUsingPost: (query: DmYzDatumLineQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultDmYzDatumLine>(
        `/screen/v2.2/waterEnvManager/dmYzDatumLine`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * @description 用于地图河流颜色渲染
     *
     * @tags 水环境管理
     * @name GetSgDmLastWaterLevelUsingPost
     * @summary 手工断面点最新水质评价
     * @request POST:/screen/v2.2/waterEnvManager/sgDmLastWaterLevel
     */
    getSgDmLastWaterLevelUsingPost: (query: LyQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListSgdmWaterLevelDto>(
        `/screen/v2.2/waterEnvManager/sgDmLastWaterLevel`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水环境管理
     * @name GetSgDmPointByLyAndGkjbUsingPost
     * @summary 手工断面点位
     * @request POST:/screen/v2.2/waterEnvManager/sgDmPoint
     */
    getSgDmPointByLyAndGkjbUsingPost: (
      query: SgDmPointByLyAndGkjbQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListCommonPointVo>(
        `/screen/v2.2/waterEnvManager/sgDmPoint`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水环境管理
     * @name GetSgMonitorHistoryCompareUsingPost
     * @summary 断面 年度和上年 评价级别列表查询接口
     * @request POST:/screen/v2.2/waterEnvManager/sgMonitorHistoryCompare
     */
    getSgMonitorHistoryCompareUsingPost: (
      query: SgMonitorHistoryCompareQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultGkSkWaterResDto>(
        `/screen/v2.2/waterEnvManager/sgMonitorHistoryCompare`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水环境管理
     * @name GetSgMonitorInfoDetailUsingPost
     * @summary 手工监测断面弹窗信息
     * @request POST:/screen/v2.2/waterEnvManager/sgMonitorInfoDetail
     */
    getSgMonitorInfoDetailUsingPost: (
      query: IdStringQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultSgDmPopVo>(
        `/screen/v2.2/waterEnvManager/sgMonitorInfoDetail`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水环境管理
     * @name GetSgMonitorStatisticsUsingPost
     * @summary 手工监测断面总数,达标统计
     * @request POST:/screen/v2.2/waterEnvManager/sgMonitorStatistics
     */
    getSgMonitorStatisticsUsingPost: (
      query: SgAndAutoMonitorStatisticsQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultWaterAssessmentDto>(
        `/screen/v2.2/waterEnvManager/sgMonitorStatistics`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水环境管理
     * @name GetSgMonitorWaterQualityStatisticsUsingPost
     * @summary 手工监测断面水质统计
     * @request POST:/screen/v2.2/waterEnvManager/sgMonitorWaterQualityStatistics
     */
    getSgMonitorWaterQualityStatisticsUsingPost: (
      query: SgMonitorWaterQualityStatisticsQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultWaterAssessmentSectionInfoResultDto>(
        `/screen/v2.2/waterEnvManager/sgMonitorWaterQualityStatistics`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水环境管理
     * @name DetailWithMnUsingPost
     * @summary 一体化自动站弹窗信息
     * @request POST:/screen/v2.2/waterEnvManager/ythzdzDetail
     */
    detailWithMnUsingPost: (query: IdStringQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultSzDetailDto>(
        `/screen/v2.2/waterEnvManager/ythzdzDetail`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水污染管理
     * @name GetCyqyByIdUsingPost
     * @summary 通过id查询餐饮企业信息
     * @request POST:/screen/v2.2/waterPollutManager/cyqyById
     */
    getCyqyByIdUsingPost: (query: IdStringQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultCyqyEntity>(
        `/screen/v2.2/waterPollutManager/cyqyById`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水污染管理
     * @name GetCyqyListUsingPost
     * @summary 餐饮企业列表
     * @request POST:/screen/v2.2/waterPollutManager/cyqyList
     */
    getCyqyListUsingPost: (query: LyQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListCyqyEntity>(
        `/screen/v2.2/waterPollutManager/cyqyList`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水污染管理
     * @name GetHourDataByWsclcUsingPost
     * @summary 污水处理厂--污染源排放最新小时数据
     * @request POST:/screen/v2.2/waterPollutManager/getHourDataByWsclc
     */
    getHourDataByWsclcUsingPost: (query: LyQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultMonitorDataGroupDto>(
        `/screen/v2.2/waterPollutManager/getHourDataByWsclc`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水污染管理
     * @name GetZdGyqyLastDataUsingPost
     * @summary 工业企业--实时监测数据2
     * @request POST:/screen/v2.2/waterPollutManager/getZdGyqyLastDatas
     */
    getZdGyqyLastDataUsingPost: (query: LyQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultZdgyqyLastDataDto>(
        `/screen/v2.2/waterPollutManager/getZdGyqyLastDatas`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水污染管理
     * @name GetGyqyCountStatisticsUsingPost
     * @summary 工业污染源--工业企业--总数统计
     * @request POST:/screen/v2.2/waterPollutManager/gyqyCountStatistics
     */
    getGyqyCountStatisticsUsingPost: (query: LyQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultWaterPollutionOnlineDto>(
        `/screen/v2.2/waterPollutManager/gyqyCountStatistics`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水污染管理
     * @name GetGyqyPieStatisticsUsingPost
     * @summary 工业污染源--工业企业--饼状图
     * @request POST:/screen/v2.2/waterPollutManager/gyqyPieStatistics
     */
    getGyqyPieStatisticsUsingPost: (query: LyQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListStatisticsCountDto>(
        `/screen/v2.2/waterPollutManager/gyqyPieStatistics`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水污染管理
     * @name GetGyqyPointUsingPost
     * @summary 工业企业--点位坐标
     * @request POST:/screen/v2.2/waterPollutManager/gyqyPoint
     */
    getGyqyPointUsingPost: (query: LyQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListCommonPointVo>(
        `/screen/v2.2/waterPollutManager/gyqyPoint`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水污染管理
     * @name GetZdgyqyRealDataUsingPost
     * @summary 工业污染源--工业企业--实时监测数据
     * @request POST:/screen/v2.2/waterPollutManager/gyqyRealData
     */
    getZdgyqyRealDataUsingPost: (query: LyQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListMapStringObject>(
        `/screen/v2.2/waterPollutManager/gyqyRealData`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水污染管理
     * @name GetGyyqCountStatisticsUsingPost
     * @summary 工业园区数量统计
     * @request POST:/screen/v2.2/waterPollutManager/gyyqCountStatistics
     */
    getGyyqCountStatisticsUsingPost: (query: LyQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultGyyqInfoCountStatisticsVo>(
        `/screen/v2.2/waterPollutManager/gyyqCountStatistics`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水污染管理
     * @name GetGyyqDetailByIdUsingPost
     * @summary 工业园区详情查看
     * @request POST:/screen/v2.2/waterPollutManager/gyyqDetail
     */
    getGyyqDetailByIdUsingPost: (query: IdStringQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultGyyqEntity>(
        `/screen/v2.2/waterPollutManager/gyyqDetail`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水污染管理
     * @name GetGyyqInventoryUsingPost
     * @summary 工业园区清单
     * @request POST:/screen/v2.2/waterPollutManager/gyyqInventory
     */
    getGyyqInventoryUsingPost: (query: LyQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListGyyqInventoryVo>(
        `/screen/v2.2/waterPollutManager/gyyqInventory`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水污染管理
     * @name GetGyyqPointUsingPost
     * @summary 工业园区点位
     * @request POST:/screen/v2.2/waterPollutManager/gyyqPoint
     */
    getGyyqPointUsingPost: (query: LyQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListCommonPointVo>(
        `/screen/v2.2/waterPollutManager/gyyqPoint`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水污染管理
     * @name GetNmscByIdUsingPost
     * @summary 通过id查询农贸市场信息
     * @request POST:/screen/v2.2/waterPollutManager/nmscById
     */
    getNmscByIdUsingPost: (query: IdStringQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultNmscEntity>(
        `/screen/v2.2/waterPollutManager/nmscById`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水污染管理
     * @name GetNmscListUsingPost
     * @summary 农贸市场列表
     * @request POST:/screen/v2.2/waterPollutManager/nmscList
     */
    getNmscListUsingPost: (query: LyQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListNmscEntity>(
        `/screen/v2.2/waterPollutManager/nmscList`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水污染管理
     * @name GetPkCountStatisticsGroupByPklxUsingPost
     * @summary 沿河排口--分类数量统计
     * @request POST:/screen/v2.2/waterPollutManager/pkCountStatisticsGroupByPklx
     */
    getPkCountStatisticsGroupByPklxUsingPost: (
      query: LyQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultYjpkCountStatisticsVO>(
        `/screen/v2.2/waterPollutManager/pkCountStatisticsGroupByPklx`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水污染管理
     * @name GetPkDetailUsingPost
     * @summary 沿河排口--弹窗详情
     * @request POST:/screen/v2.2/waterPollutManager/pkDetail
     */
    getPkDetailUsingPost: (query: IdStringQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultPkDetailDto>(
        `/screen/v2.2/waterPollutManager/pkDetail`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水污染管理
     * @name GetScyzByIdUsingPost
     * @summary 水产养殖点位弹窗信息
     * @request POST:/screen/v2.2/waterPollutManager/scyzById
     */
    getScyzByIdUsingPost: (query: IdStringQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultScyzDetailDto>(
        `/screen/v2.2/waterPollutManager/scyzById`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水污染管理
     * @name GetScyzListUsingPost
     * @summary 水产养殖列表
     * @request POST:/screen/v2.2/waterPollutManager/scyzList
     */
    getScyzListUsingPost: (query: LyQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListScyzDto>(
        `/screen/v2.2/waterPollutManager/scyzList`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水污染管理
     * @name GetScyzPieStatisticsUsingPost
     * @summary 水产养殖--镇街统计
     * @request POST:/screen/v2.2/waterPollutManager/scyzPieStatistics
     */
    getScyzPieStatisticsUsingPost: (query: LyQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListStatisticsCountDto>(
        `/screen/v2.2/waterPollutManager/scyzPieStatistics`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水污染管理
     * @name GetScyzStatisticsCountGroupByZjUsingPost
     * @summary 水产养殖--镇街统计
     * @request POST:/screen/v2.2/waterPollutManager/scyzStatisticsCountGroupByZj
     */
    getScyzStatisticsCountGroupByZjUsingPost: (
      query: LyQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListStatisticsCountDto>(
        `/screen/v2.2/waterPollutManager/scyzStatisticsCountGroupByZj`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水污染管理
     * @name GetWryOverviewDataStatisticsUsingPost
     * @summary 污染源总览--数据统计
     * @request POST:/screen/v2.2/waterPollutManager/wryOverviewDataStatistics
     */
    getWryOverviewDataStatisticsUsingPost: (
      query: LyQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultWryPreStatisticsVo>(
        `/screen/v2.2/waterPollutManager/wryOverviewDataStatistics`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水污染管理
     * @name GetWryOverviewDataStatisticsPieUsingPost
     * @summary 污染源总览--占比分析饼状图
     * @request POST:/screen/v2.2/waterPollutManager/wryOverviewDataStatisticsPie
     */
    getWryOverviewDataStatisticsPieUsingPost: (
      query: LyQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListWryStatisticsCountDto>(
        `/screen/v2.2/waterPollutManager/wryOverviewDataStatisticsPie`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水污染管理
     * @name GetWryOverviewHotMapUsingPost
     * @summary 污染源总览--污染源分布热力图
     * @request POST:/screen/v2.2/waterPollutManager/wryOverviewHotMap
     */
    getWryOverviewHotMapUsingPost: (query: WryHotMapQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListJSONArray>(
        `/screen/v2.2/waterPollutManager/wryOverviewHotMap`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水污染管理
     * @name EmissionStatisticsUsingGet
     * @summary 污染源总览--污染源排放统计
     * @request GET:/screen/v2.2/waterPollutManager/wryOverviewStatistics
     */
    emissionStatisticsUsingGet: (
      query?: { ly?: string; timeUnit?: string },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultWaterPollutionEmissionStatisticsDto>(
        `/screen/v2.2/waterPollutManager/wryOverviewStatistics${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水污染管理
     * @name GetWsPkListUsingPost
     * @summary 沿河排口--列表清单
     * @request POST:/screen/v2.2/waterPollutManager/wsPkList
     */
    getWsPkListUsingPost: (query: LyAndPkLxQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListPkListVo>(
        `/screen/v2.2/waterPollutManager/wsPkList`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水污染管理
     * @name GetWsPkPieStatisticsUsingPost
     * @summary 污水排口--饼状图统计
     * @request POST:/screen/v2.2/waterPollutManager/wsPkPieStatistics
     */
    getWsPkPieStatisticsUsingPost: (cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListStatisticsCountDto>(
        `/screen/v2.2/waterPollutManager/wsPkPieStatistics`,
        'POST',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水污染管理
     * @name GetWsclcCountStatisticsUsingPost
     * @summary 污水处理厂--总数统计
     * @request POST:/screen/v2.2/waterPollutManager/wsclcCountStatistics
     */
    getWsclcCountStatisticsUsingPost: (query: LyQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultWaterPollutionOnlineDto>(
        `/screen/v2.2/waterPollutManager/wsclcCountStatistics`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水污染管理
     * @name WsclcOutPutListUsingPost
     * @summary 污水处理厂--获取排口列表
     * @request POST:/screen/v2.2/waterPollutManager/wsclcOutPutList
     */
    wsclcOutPutListUsingPost: (query: IdStringQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListWsclcInfoItemsDto>(
        `/screen/v2.2/waterPollutManager/wsclcOutPutList`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水污染管理
     * @name GetWsclcPfGmPieClickPointUsingPost
     * @summary 污水处理厂--排放规模饼状图点击
     * @request POST:/screen/v2.2/waterPollutManager/wsclcPfGmPieClickPoint
     */
    getWsclcPfGmPieClickPointUsingPost: (
      query: WsclcPieClickPointQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListCommonPointVo>(
        `/screen/v2.2/waterPollutManager/wsclcPfGmPieClickPoint`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水污染管理
     * @name GetWsclcPfGmStatisticsUsingPost
     * @summary 污水处理厂--污水处理厂排放规模统计
     * @request POST:/screen/v2.2/waterPollutManager/wsclcPfGmStatistics
     */
    getWsclcPfGmStatisticsUsingPost: (query: LyQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListStatisticsCountUnitDto>(
        `/screen/v2.2/waterPollutManager/wsclcPfGmStatistics`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水污染管理
     * @name WsclcPointsUsingPost
     * @summary 污水处理厂--点位
     * @request POST:/screen/v2.2/waterPollutManager/wsclcPoints
     */
    wsclcPointsUsingPost: (query: LyQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListWsclcInfoModel>(
        `/screen/v2.2/waterPollutManager/wsclcPoints`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水污染管理
     * @name GetWsclcRealTimeDataUsingPost
     * @summary 污水处理厂--污染源排放实时监测
     * @request POST:/screen/v2.2/waterPollutManager/wsclcRealTimeData
     */
    getWsclcRealTimeDataUsingPost: (query: LyQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListMapStringObject>(
        `/screen/v2.2/waterPollutManager/wsclcRealTimeData`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水污染管理
     * @name GetWsclcRealTimeData2UsingPost
     * @summary 污水处理厂--污染源排放实时监测（带表头）
     * @request POST:/screen/v2.2/waterPollutManager/wsclcRealTimeData2
     */
    getWsclcRealTimeData2UsingPost: (query: LyQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultZdgyqyLastDataDto>(
        `/screen/v2.2/waterPollutManager/wsclcRealTimeData2`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水污染管理
     * @name WsclcStatisticsClickPointUsingPost
     * @summary 污水处理厂--污水处理厂统计，点击获取点位
     * @request POST:/screen/v2.2/waterPollutManager/wsclcStatisticsClickPoint
     */
    wsclcStatisticsClickPointUsingPost: (
      query: WsclcClickPointQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListJSONObject>(
        `/screen/v2.2/waterPollutManager/wsclcStatisticsClickPoint`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水污染管理
     * @name GetXqyzListUsingPost
     * @summary 畜禽养殖列表
     * @request POST:/screen/v2.2/waterPollutManager/xqyzList
     */
    getXqyzListUsingPost: (query: LyQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListXqyzDto>(
        `/screen/v2.2/waterPollutManager/xqyzList`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水污染管理
     * @name GetXqyzPieStatisticsUsingPost
     * @summary 畜禽养殖--饼状图统计
     * @request POST:/screen/v2.2/waterPollutManager/xqyzPieStatistics
     */
    getXqyzPieStatisticsUsingPost: (query: LyQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListStatisticsCountDto>(
        `/screen/v2.2/waterPollutManager/xqyzPieStatistics`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水污染管理
     * @name GetXqyzStatisticsCountGroupByZjUsingPost
     * @summary 畜禽养殖--镇街统计
     * @request POST:/screen/v2.2/waterPollutManager/xqyzStatisticsCountGroupByZj
     */
    getXqyzStatisticsCountGroupByZjUsingPost: (
      query: LyQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListStatisticsCountDto>(
        `/screen/v2.2/waterPollutManager/xqyzStatisticsCountGroupByZj`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水资源管理
     * @name DfBasicInfoUsingPost
     * @summary 堤防工程-堤防基本信息（搜索）
     * @request POST:/screen/v2.2/waterResManager/dfBasicInfo
     */
    dfBasicInfoUsingPost: (query: SKBasicInfoReqDto, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListDfBasicDTO>(
        `/screen/v2.2/waterResManager/dfBasicInfo`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水资源管理
     * @name SdfnfoListUsingPost
     * @summary 堤防工程-堤防列表
     * @request POST:/screen/v2.2/waterResManager/dfInfoList
     */
    sdfnfoListUsingPost: (query: SKBasicInfoReqDto, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultPageListDfInfoDto>(
        `/screen/v2.2/waterResManager/dfInfoList`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水资源管理
     * @name DfInfoOverviewUsingPost
     * @summary 堤防工程-堤防信息概览
     * @request POST:/screen/v2.2/waterResManager/dfInfoOverview
     */
    dfInfoOverviewUsingPost: (query: LyQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultDfInfoOverviewResDto>(
        `/screen/v2.2/waterResManager/dfInfoOverview`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水资源管理
     * @name GscInfoBasicUsingPost
     * @summary 供水厂-基本信息（搜索）
     * @request POST:/screen/v2.2/waterResManager/gscInfoBasic
     */
    gscInfoBasicUsingPost: (query: SKBasicInfoReqDto, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListJSONObject>(
        `/screen/v2.2/waterResManager/gscInfoBasic`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水资源管理
     * @name GscInfoListUsingPost
     * @summary 供水厂-列表
     * @request POST:/screen/v2.2/waterResManager/gscInfoList
     */
    gscInfoListUsingPost: (query: SKBasicInfoReqDto, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultPageListGscInfoDto>(
        `/screen/v2.2/waterResManager/gscInfoList`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水资源管理
     * @name GscInfoOverviewUsingPost
     * @summary 供水厂-信息概览
     * @request POST:/screen/v2.2/waterResManager/gscInfoOverview
     */
    gscInfoOverviewUsingPost: (query: SKBasicInfoReqDto, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultGscInfoOverviewResDto>(
        `/screen/v2.2/waterResManager/gscInfoOverview`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水资源管理
     * @name QskInfoBasicUsingPost
     * @summary 取水口-基本信息（搜索）
     * @request POST:/screen/v2.2/waterResManager/qskInfoBasic
     */
    qskInfoBasicUsingPost: (query: SKBasicInfoReqDto, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListQskInfoDto>(
        `/screen/v2.2/waterResManager/qskInfoBasic`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水资源管理
     * @name QskInfoListUsingPost
     * @summary 取水口-列表
     * @request POST:/screen/v2.2/waterResManager/qskInfoList
     */
    qskInfoListUsingPost: (query: SKBasicInfoReqDto, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultPageListQskInfoDto>(
        `/screen/v2.2/waterResManager/qskInfoList`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水资源管理
     * @name QskInfoOverviewUsingPost
     * @summary 取水口-信息概览
     * @request POST:/screen/v2.2/waterResManager/qskInfoOverview
     */
    qskInfoOverviewUsingPost: (query: SKBasicInfoReqDto, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultQskInfoOverviewResDto>(
        `/screen/v2.2/waterResManager/qskInfoOverview`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水资源管理
     * @name GetSgnqSzmbListUsingPost
     * @summary 三条红线--水功能区--水质目标列表
     * @request POST:/screen/v2.2/waterResManager/sgnqSzmbList
     */
    getSgnqSzmbListUsingPost: (query: LyQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListSgnqWaterTargetVo>(
        `/screen/v2.2/waterResManager/sgnqSzmbList`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水资源管理
     * @name SkBasicInfoUsingPost
     * @summary 水库工程-水库基本信息（搜索）
     * @request POST:/screen/v2.2/waterResManager/skBasicInfo
     */
    skBasicInfoUsingPost: (query: SKBasicInfoReqDto, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListSkInfoDto>(
        `/screen/v2.2/waterResManager/skBasicInfo`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水资源管理
     * @name SkInfoListUsingPost
     * @summary 水库工程-水库列表
     * @request POST:/screen/v2.2/waterResManager/skInfoList
     */
    skInfoListUsingPost: (query: SKBasicInfoReqDto, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultPageListSkInfoDto>(
        `/screen/v2.2/waterResManager/skInfoList`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水资源管理
     * @name SkInfoOverviewUsingPost
     * @summary 水库工程-水库信息概览
     * @request POST:/screen/v2.2/waterResManager/skInfoOverview
     */
    skInfoOverviewUsingPost: (query: LyQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultSkInfoOverviewResDto>(
        `/screen/v2.2/waterResManager/skInfoOverview`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水资源管理
     * @name GetSwMonitorRealTimeUsingPost
     * @summary 水文监测-实时监测
     * @request POST:/screen/v2.2/waterResManager/swMonitorRealTime
     */
    getSwMonitorRealTimeUsingPost: (
      query: SwMonitorRealTimeQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListSwslSsjcDto>(
        `/screen/v2.2/waterResManager/swMonitorRealTime`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水资源管理
     * @name GetSwMonitorSiteStatisticsUsingPost
     * @summary 水文监测--站点统计
     * @request POST:/screen/v2.2/waterResManager/swMonitorSiteStatistics
     */
    getSwMonitorSiteStatisticsUsingPost: (query: LyQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultSwslZdtjDto>(
        `/screen/v2.2/waterResManager/swMonitorSiteStatistics`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水资源管理
     * @name GetSwSiteDetailAndGraphUsingPost
     * @summary 水文监测-水文站点详情(含数据图数据)
     * @request POST:/screen/v2.2/waterResManager/swSiteDetailAndGraph
     */
    getSwSiteDetailAndGraphUsingPost: (
      query: SwSiteDetailAndGraphQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultSwslSiteInfo>(
        `/screen/v2.2/waterResManager/swSiteDetailAndGraph`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水资源管理
     * @name GetSwSiteStandardLineUsingPost
     * @summary 水文监测-基准线
     * @request POST:/screen/v2.2/waterResManager/swSiteStandardLine
     */
    getSwSiteStandardLineUsingPost: (
      query: SwSiteStandardLineQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultSwSiteStandardLineVo>(
        `/screen/v2.2/waterResManager/swSiteStandardLine`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水资源管理
     * @name SzBasicInfoUsingPost
     * @summary 水闸工程-水闸基本信息（搜索）
     * @request POST:/screen/v2.2/waterResManager/szBasicInfo
     */
    szBasicInfoUsingPost: (query: SKBasicInfoReqDto, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListSzInfoDto>(
        `/screen/v2.2/waterResManager/szBasicInfo`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水资源管理
     * @name SzInfoListUsingPost
     * @summary 水闸工程-水闸列表
     * @request POST:/screen/v2.2/waterResManager/szInfoList
     */
    szInfoListUsingPost: (query: SKBasicInfoReqDto, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultPageListSzInfoDto>(
        `/screen/v2.2/waterResManager/szInfoList`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水资源管理
     * @name SzInfoOverviewUsingPost
     * @summary 水闸工程-水闸信息概览
     * @request POST:/screen/v2.2/waterResManager/szInfoOverview
     */
    szInfoOverviewUsingPost: (query: LyQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultSzInfoOverviewResDto>(
        `/screen/v2.2/waterResManager/szInfoOverview`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水资源管理
     * @name YdtsInfoListUsingPost
     * @summary 引调提水工程-列表
     * @request POST:/screen/v2.2/waterResManager/ydtsInfoList
     */
    ydtsInfoListUsingPost: (query: SKBasicInfoReqDto, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListYdTsBasicDTO>(
        `/screen/v2.2/waterResManager/ydtsInfoList`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水资源管理
     * @name YdtsInfoOverviewUsingPost
     * @summary 引调提水工程-信息概览
     * @request POST:/screen/v2.2/waterResManager/ydtsInfoOverview
     */
    ydtsInfoOverviewUsingPost: (query: LyQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultYdtsInfoOverviewResDto>(
        `/screen/v2.2/waterResManager/ydtsInfoOverview`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水资源管理
     * @name GetYysCountStatisticsUsingPost
     * @summary 饮用水源地--饮用水源地概览
     * @request POST:/screen/v2.2/waterResManager/yysCountStatistics
     */
    getYysCountStatisticsUsingPost: (query: LyQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultYysydCountStatisticsVo>(
        `/screen/v2.2/waterResManager/yysCountStatistics`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水资源管理
     * @name GetYysMonitorInfoDetailUsingPost
     * @summary 饮用水源地--点位弹窗信息
     * @request POST:/screen/v2.2/waterResManager/yysMonitorInfoDetail
     */
    getYysMonitorInfoDetailUsingPost: (
      query: IdStringQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultYysMonitorInfoDetailVo>(
        `/screen/v2.2/waterResManager/yysMonitorInfoDetail`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水资源管理
     * @name GetYysydInfoStatisticsUsingPost
     * @summary 饮用水源地--饮用水源地监测情况
     * @request POST:/screen/v2.2/waterResManager/yysydInfoStatistics
     */
    getYysydInfoStatisticsUsingPost: (
      query: LyAndYearQuery,
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListYysydInfoStatisticsVo>(
        `/screen/v2.2/waterResManager/yysydInfoStatistics`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 水资源管理
     * @name GetZrcsListUsingPost
     * @summary 三条红线--用水总量控制--责任及措施清单
     * @request POST:/screen/v2.2/waterResManager/zrcsList
     */
    getZrcsListUsingPost: (query: LyQuery, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListProblemMeasuresDto>(
        `/screen/v2.2/waterResManager/zrcsList`,
        'POST',
        query,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 智慧河长大屏-河长工作-考核排名接口
     * @name GetRankingsByXzqhUsingGet
     * @summary 获取行政区划对应的考核信息
     * @request GET:/screen/zhhz/hzgz/assessmentRankings/getRankingsByXzqh
     */
    getRankingsByXzqhUsingGet: (
      query: { ly?: string; month: string; xzqh: string },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultAssessmentRankingsDto>(
        `/screen/zhhz/hzgz/assessmentRankings/getRankingsByXzqh${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 智慧河长大屏-河长工作-考核排名接口
     * @name GetRankingsDetailUsingGet
     * @summary 获取考核信息详情
     * @request GET:/screen/zhhz/hzgz/assessmentRankings/getRankingsDetail
     */
    getRankingsDetailUsingGet: (
      query: { ly?: string; month: string },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListAssessmentRankingsDto>(
        `/screen/zhhz/hzgz/assessmentRankings/getRankingsDetail${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 智慧河长大屏-河长工作-考核排名接口
     * @name GetRankingsListUsingGet
     * @summary 获取各镇街水环境整治综合考核排名
     * @request GET:/screen/zhhz/hzgz/assessmentRankings/getRankingsList
     */
    getRankingsListUsingGet: (
      query: { ly?: string; month: string },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultListRankingsListDtos>(
        `/screen/zhhz/hzgz/assessmentRankings/getRankingsList${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),

    /**
     * No description
     *
     * @tags 智慧河长大屏-河长工作-考核排名接口
     * @name GetSzQgwtUsingGet
     * @summary 获取水质评价及”千沟万塘“断面水质情况
     * @request GET:/screen/zhhz/hzgz/assessmentRankings/getSz_Qgwt
     */
    getSzQgwtUsingGet: (
      query: { ly?: string; month: string; xzqh: string },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request<JsonResultSzAndQgwtDetailDto>(
        `/screen/zhhz/hzgz/assessmentRankings/getSz_Qgwt${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),
  }
  wrj = {
    /**
     * No description
     *
     * @tags 无人机接口
     * @name GetWrjPathListUsingGet
     * @summary 无人机地图上展示数据
     * @request GET:/wrj/wrjPathList
     */
    getWrjPathListUsingGet: (query?: { ly?: string }, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListWrjPathDto>(
        `/wrj/wrjPathList${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),
  }
}
